import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Spinner,
  InputGroup,
  Accordion,
  Modal,
} from "react-bootstrap";
import { Autocomplete, Box, Chip, TextField, Tooltip } from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
// import ProductAndServiceSection from "../Enquiry/DynamicProductAndServiceForm";

import AgentDetailsSection from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/AgentDetailsSection";
import AssignedMemberSection, {
  Member,
} from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/AssignedMemberSection";
import BillingFromAddress from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/BillingFromAddress";
import { AppDispatch } from "index";
import {
  fetchProductQuotationById,
  fetchServiceQuotationById,
  fetchServiceQuotationDynamicDropdown,
} from "slices/quotation/thunk";
import { MecordColors } from "../../../../Constants/Color";
import { Agent } from "Common/CommonEnquiryData/EnquiryType";
import { useQuotationCalculations } from "Common/Hooks/UseCalculationForQuotationAndSalesOrder";
import {
  AssignedMemberDetailRetrive,
  initialPBGDetail,
  initialSalesOrderData,
  SalesOrderDataRetrive,
} from "Common/CommonEnquiryData/SalesOrderServiceType";
import { buildSalesOrderPayload } from "Common/CommonEnquiryData/ServiceSalesOrderPayload";
import FormBreadcrumb from "Common/Components/FormBreadcrumb/FormBreadcrumb";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import * as Yup from "yup";
import { useFormik, FormikProvider } from "formik";
import FileUpload from "Common/Components/FileUpload.tsx/FileUpload";
import CurrencyExchangeSection from "Common/CurrencyExchangeSection/CurrencyExchangeSection";
import { Axios } from "api/axios";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import LoadingSpinner from "Common/Components/LoaderErrorWrapper/LoadingSpinner";
// import ProductAndServiceSection from "./DynamicProductAndServiceForm";
import FormActionButtons from "pages/QuotationV2/Form/Components/FormActionButtons";
import CompanyFormModal from "../../components/CompanyFormModal";
import { fetchCompanyByDropDown } from "slices/Masters/company/thunk";
import ProductFormModal from "../../components/ProductFormModal";
import { fetchCategories } from "slices/enquiry/thunk";
import ServiceFormModal from "../../components/ServiceFormModal";
import { fetchTechnicianDropdown } from "slices/UserManagement/user/thunk";
import TermsConditionsSection from "pages/QuotationV2/Form/Sections/TermsConditionsSection";
import RetentionDetails from "../../components/RetentaionDetails";
import NotesAndAttachments from "../../components/NotesAndAttachments";
import ScheduleFollowUp from "../../components/ScheduleFollowUp";
import AddTags from "../../components/AddTagsForSalesOrder";
import { autocompleteDropdownStyles } from "Constants/Style";
import { showConfirm } from "helpers/swalHelper";
import { useScrollToFormikError } from "hooks/useScrollToFormikError";
import ServiceSection from "./ServiceSection";
import EnquiryServiceForm from "./ServiceSection";
import AddressFormModal from "pages/Enquiry/Components/AddressFormModal";
import { fetchServiceSalesOrderDropdownForQuotationNumber } from "slices/sales_order/thunk";
import AddCustomerModal from "pages/QuotationV2/Form/Components/AddCustomerModal";
import { fetchModelByDropDown } from "slices/Masters/model/thunk";
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ClearIcon from '@mui/icons-material/Clear';

const mapAssignedMembersFromQuotation = (assignedMembers: any[] = [], membersOptions: any[] = []) => {
  return assignedMembers
    .map((member: any) => {
      const userId = member.user_id || member.id;
      if (!userId) return null;
      const option = membersOptions.find((opt: any) => (opt.user_id || opt.id) === userId);
      const source = option || member;
      const firstName = source.first_name || member.first_name || "";
      const lastName = source.last_name || member.last_name || "";
      const fullName =
        source.full_name ||
        source.fullname ||
        source.name ||
        `${firstName} ${lastName}`.trim() ||
        source.username ||
        "";

      return {
        ...source,
        id: userId,
        user_id: userId,
        fullname: fullName,
        name: fullName,
        username: source.username || source.email || "",
      };
    })
    .filter(Boolean);
};

const mapTechniciansFromQuotation = (technicians: any[] = [], technicianOptions: any[] = []) => {
  return technicians
    .map((technician: any) => {
      const userId = technician.user_id || technician.id;
      if (!userId) return null;
      const option = technicianOptions.find((opt: any) => (opt.user_id || opt.id) === userId);
      const source = option || technician;
      const firstName = source.first_name || technician.first_name || "";
      const lastName = source.last_name || technician.last_name || "";
      const fullName =
        source.full_name ||
        source.fullname ||
        source.name ||
        `${firstName} ${lastName}`.trim() ||
        source.username ||
        "";

      return {
        ...source,
        id: userId,
        user_id: userId,
        name: fullName,
        fullname: fullName,
      };
    })
    .filter(Boolean);
};


// Helper function to convert UTC date to local date string (YYYY-MM-DD format)
// Backend returns UTC dates, we need to convert to local for display
const formatDateToDisplay = (utcDateStr: string | null | undefined): string => {
  if (!utcDateStr) return "";
  try {
    // Parse UTC date string
    const utcDate = new Date(utcDateStr);
    if (isNaN(utcDate.getTime())) return "";

    // Get local date components
    const year = utcDate.getFullYear();
    const month = String(utcDate.getMonth() + 1).padStart(2, "0");
    const day = String(utcDate.getDate()).padStart(2, "0");

    // Return in YYYY-MM-DD format (for HTML date input)
    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};

// Helper function to get initials from first and last name
const getInitials = (firstName: string, lastName: string): string => {
  const first = firstName?.charAt(0) || "";
  const last = lastName?.charAt(0) || "";
  return (first + last).toUpperCase();
};

// Helper function to format full address with city, country, and pincode
const formatFullAddress = (addressObj: any): string => {
  if (!addressObj) return "";
  
  const parts = [];
  if (addressObj.address) parts.push(addressObj.address);
  if (addressObj.city) parts.push(addressObj.city);
  if (addressObj.country) parts.push(addressObj.country);
  if (addressObj.pin_code || addressObj.pincode) parts.push(addressObj.pin_code || addressObj.pincode);
  
  return parts.length > 0 ? parts.join(", ") : "";
};

// Helper function to transform terms and conditions - group by type to handle multiple options per type
const transformTermsAndConditions = (terms_and_conditions: any): any[] => {
  if (!terms_and_conditions) return [];

  // Handle object (non-array) case
  let termsArray: any[] = [];
  if (Array.isArray(terms_and_conditions)) {
    termsArray = terms_and_conditions;
  } else if (typeof terms_and_conditions === "object") {
    termsArray = Object.values(terms_and_conditions);
  } else {
    return [];
  }

  if (termsArray.length === 0) return [];

  // Check if already in form format (has description with newlines or id field)
  const isFormFormat = termsArray.some((term: any) =>
    (term.description && term.description.includes("\n")) || term.id
  );

  if (isFormFormat) {
    // Already in form format - group by type and merge options
    const groupedByType: Record<string, string[]> = {};
    termsArray.forEach((term: any) => {
      if (term.type) {
        if (!groupedByType[term.type]) {
          groupedByType[term.type] = [];
        }
        // Extract options from description (newline-separated) or from option/options field
        if (term.description && term.description.includes("\n")) {
          const options = term.description.split("\n").filter((opt: string) => opt.trim() !== "");
          options.forEach((opt: string) => {
            if (!groupedByType[term.type].includes(opt.trim())) {
              groupedByType[term.type].push(opt.trim());
            }
          });
        } else if (term.description) {
          const opt = term.description.trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        } else if (term.option) {
          const opt = term.option.trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        } else if (term.options) {
          const opt = typeof term.options === 'string' ? term.options.trim() : String(term.options).trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        }
      }
    });

    return Object.entries(groupedByType).map(
      ([type, options], index) => ({
        id: `term-${index}-${Date.now()}-${Math.random()}`,
        type: type,
        option: options[0] || "",
        description: options.join("\n"),
      })
    );
  } else {
    // Backend format: array of {type, options} - group by type
    const groupedByType: Record<string, string[]> = {};
    termsArray.forEach((term: any) => {
      if (term.type && term.options) {
        if (!groupedByType[term.type]) {
          groupedByType[term.type] = [];
        }
        const option = typeof term.options === 'string' ? term.options.trim() : String(term.options).trim();
        if (option && !groupedByType[term.type].includes(option)) {
          groupedByType[term.type].push(option);
        }
      }
    });

    return Object.entries(groupedByType).map(
      ([type, options], index) => ({
        id: `term-${index}-${Date.now()}-${Math.random()}`,
        type: type,
        option: options[0] || "",
        description: options.join("\n"),
      })
    );
  }
};

const normalizeAttachmentUrls = (attachments: any): string[] =>
  Array.isArray(attachments)
    ? attachments
        .map((attachment: any) =>
          typeof attachment === "string"
            ? attachment
            : attachment?.file_url || attachment?.url || "",
        )
        .filter(Boolean)
    : [];

// Re-define component props, referencing new types
export interface AddServicesSalesOrderForm {

  isEdit: boolean;
  id?: string;
  initialData: any; // The full API response
  companies: any[]; // Using 'any' as Company type not fully defined here
  // sources: string[];
  onSave: (payload: any, action: "draft" | "print" | "save") => Promise<void>;
  // categories: any[];
  // subcategories: any[];
  // makes: any[];
  // models: any[];
  // fetchSubcategories: (categoryId: string) => void;
  // fetchMakes?: (params: { categoryId: string; subcategoryId: string }) => void;
  // fetchModels?: (params: {
  //   categoryId: string;
  //   subcategoryId: string;
  //   makeId: string;
  // }) => void;
  membersOptions: any[]; // <-- all assignable users
  // products?: {};
  enquiryReferences: string; // Should be array of objects for Autocomplete
  organizationsState?: any[]; // Optional - BillingFromAddress component will fetch its own
}

const AddServicesSalesOrderForm: React.FC<
  AddServicesSalesOrderForm
> = ({

  isEdit,
  initialData,
  companies,
  // sources,
  onSave,
  // categories,
  // subcategories,
  // makes,
  // models,
  // fetchSubcategories,
  // fetchMakes,
  // fetchModels,
  membersOptions,
  // products = {},
  organizationsState,
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { state }: any = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false); // For data loading
    const [saving, setSaving] = useState(false); // For Save button
    const [savingDraft, setSavingDraft] = useState(false); // For Save and Draft button
    const [validationAttemptCount, setValidationAttemptCount] = useState(0);
    // const [formData, setFormData] = useState<SalesOrderDataRetrive>(
    //   initialSalesOrderData
    // );

    const { id: routeId, enquiry_type: pro_type } = useParams<{
      id: string;
      enquiry_type: string;
    }>();

    const [items, setItems] = useState<any[]>([]);
    const [shippingAddresses, setShippingAddresses] = useState<
      {
        id: string;
        address: string;
        state?: string;
        city?: string;
        pin_code?: string;
      }[]
    >([]);
    // Autocomplete option states (MUI requires objects)
    const [pbgStatusOptions] = useState(["Received", "Pending", "Waived"]);
    const [statusOptions] = useState(["In Progress", "Completed", "Cancelled"]);
    const [selectedQuotation, setSelectedQuotation] = useState<any>(null);
    const [quotationReferences, setQuotationReferences] = useState<any[]>([]);
    const [quotationData, setQuotationData] = useState<any>(null);
    const [generalFile, setGeneralFile] = useState<File | null>(null);
    const [isGeneratingUid, setIsGeneratingUid] = useState(false);
    const isUserSelectingQuotation = useRef(false);
    const [showCompanyModal, setShowCompanyModal] = useState(false);
    const [showProductModal, setShowProductModal] = useState(false);
    const [showServiceModal, setShowServiceModal] = useState(false);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [selectedMemberIds, setSelectedMemberIds] = useState<string[]>([]);

    const retentionTypeOptions = [
      { label: "Percentage", value: "percentage" },
      { label: "Amount", value: "amount" },
    ];

    interface CompositionOption {
      gst_id: string;
      gst_percentage: string;
    }
    const [compositionList, setCompositionList] = useState<CompositionOption[]>(
      []
    );

    const [currencyList, setCurrencyList] =
      useState<{ label: string; value: string }[]>();

    const [tableExchange, setTableExchange] = useState<string | number>("");
    const [technicianOptions, setTechnicianOptions] = useState<any[]>([]);
    const [selectedTechnicianIds, setSelectedTechnicianIds] = useState<string[]>([]);

    const validationSchema = Yup.object().shape({
      // Sales Order Details Validations
      srv_date: Yup.date()
        .required("Order date is required")
        .typeError("Invalid order date"),
      schedule_service_date: Yup.date()
        .required("Schedule Service Date is required")
        .typeError("Invalid Schedule Service Date"),
      quotation_number: Yup.string().nullable(),
      quotation: Yup.string().nullable(), // can be null (no need for required)
      initiated_by: Yup.string().required("Initiated by is required"),
      status: Yup.string().nullable(), // dropdown — allow empty
      enquiry_number: Yup.string().nullable(), // autofill — no validation
      enquiry: Yup.string().nullable(), // can be null (no need for required)

      // Customer Details Validations
      company_id: Yup.string().nullable(),
      company_name: Yup.string().required("Company name is required"),
      contactPersonArray: Yup.array()
        .min(1, "At least select one contact person")
        .required("At least select one contact person"),
      industry_name: Yup.string().nullable(),
      company_email: Yup.string().email("Invalid email format").nullable(),
      billing_address: Yup.object().nullable(), // optional, autofill
      bill_from_address: Yup.mixed()
        .required("Bill From address is required")
        .test(
          "is-valid-bill-from-address",
          "Bill From address is required",
          (value: any) => {
            if (!value) return false;
            // If it's a string, check if it's not empty
            if (typeof value === "string") {
              return value.trim() !== "";
            }
            // If it's an object, check if it has org_address or address fields
            if (typeof value === "object" && !Array.isArray(value)) {
              // Check if it's an empty object
              if (Object.keys(value).length === 0) return false;
              // Check if it has org_address or address field
              return !!(value.org_address || value.address);
            }
            return false;
          }
        ),
      // Contact persons (multiple)
      contact_details: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.string().nullable(),
            contact_person_name: Yup.string().required(
              "Contact person name is required"
            ),
            contact_person_email: Yup.string()
              .email("Invalid email format")
              .nullable(),
            contact_person_phone_no: Yup.string().nullable(),
            contact_person_department: Yup.string().nullable(),
            contact_person_designation: Yup.string().nullable(),
          })
        )
        .nullable(),
      // PO fields (top-level)
      customer_po_number: Yup.string().nullable(),
      customer_po_date: Yup.string().nullable(),
      customer_po_document_url: Yup.mixed().nullable(),

      // // Agent Details Validations
      // agent: Yup.object()
      //   .shape({
      //     agent_name: Yup.string().nullable(), // can be null
      //   })
      //   .nullable(),

      // Members Staff Validation
      members: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.string().required("Member ID is required"),
            fullname: Yup.string().nullable(),
            username: Yup.string().nullable(),
            name: Yup.string().nullable(),
            user_id: Yup.string().nullable(),
          })
        )
        .nullable(),

      // PBG Details Validations
      pbg_details: Yup.object({
        pbg_required: Yup.boolean().default(false),

        pbg_number: Yup.string().when("pbg_required", {
          is: true,
          then: (schema) => schema.required("PBG Number is required"),
          otherwise: (schema) => schema,
        }),

        pbg_date: Yup.string().when("pbg_required", {
          is: true,
          then: (schema) => schema.required("PBG Date is required"),
          otherwise: (schema) => schema,
        }),

        bank_name: Yup.string().when("pbg_required", {
          is: true,
          then: (schema) => schema.required("Bank Name is required"),
          otherwise: (schema) => schema,
        }),

        amount: Yup.number().when("pbg_required", {
          is: true,
          then: (schema) =>
            schema
              .required("Amount is required")
              .typeError("Amount must be a number")
              .min(0, "PBG Amount cannot be negative"),
          otherwise: (schema) => schema,
        }),

        validity: Yup.string().when("pbg_required", {
          is: true,
          then: (schema) => schema.required("Validity is required"),
          otherwise: (schema) => schema,
        }),

        pbg_status: Yup.string().when("pbg_required", {
          is: true,
          then: (schema) => schema.required("PBG Status is required"),
          otherwise: (schema) => schema,
        }),

        upload_document: Yup.mixed().nullable(),
      }),

      // Currency & GST/TAXATION
      currency_code: Yup.string().default("INR").required("Currency is required"),
      currency_symbol: Yup.string().nullable(),

      exchange_rate: Yup.string().when("currency_code", {
        is: (val: string) => val !== "IND",
        then: (schema) => schema.required("Exchange rate is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      composition_gst: Yup.boolean(),

      select_composition_gst: Yup.string().when("composition_gst", {
        is: (val: boolean) => val === true,
        then: (schema) =>
          schema.required("Composition GST selection is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      // Payment Terms
      payment_terms: Yup.string().nullable(),
      payment_terms_amount: Yup.number().typeError("Must be a number").nullable().transform((v) => (v === "" || v === null || v === undefined ? null : v)),
      advance_payment: Yup.number().typeError("Must be a number").nullable(),
      pending_payment: Yup.number().typeError("Must be a number").nullable(),
      next_credit_schedule: Yup.string().nullable(),
      payment_reminder: Yup.number().typeError("Must be a number").nullable(),

      // Inspection & Installation Date (commented out in form, so making optional)

      inspection: Yup.string().nullable(), // Optional since field is not shown in service sales order form
      inspection_date: Yup.string().when("inspection", {
        is: (val: string) => val === "Applicable",
        then: (schema) => schema.required("Inspection Date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      installation: Yup.string().nullable(),
      installation_date: Yup.string().when("installation", {
        is: (val: string) => val === "Applicable",
        then: (schema) => schema.required("Installation Date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
      technicians: Yup.array()
        .of(
          Yup.object().shape({
            // id: Yup.string().nullable(),
            // user_id: Yup.string().nullable(),
            first_name: Yup.string().nullable(),
            last_name: Yup.string().nullable(),
            username: Yup.string().nullable(),
          })
        )
        .min(1, "At least one technician is required.")
        .required("At least one technician is required."),

      // Retention Details (optional)
      retention_details: Yup.object().shape({
        retention_applicable: Yup.boolean().default(false),
        retentionType: Yup.string().nullable(),
        percentage: Yup.number()
          .min(0, "Percentage cannot be negative")
          .max(100, "Percentage cannot be more than 100")
          .nullable(),
        retentionAmount: Yup.number().min(0, "Amount cannot be negative").nullable(),
        followUpDate: Yup.string().nullable(),
      }),

      next_follow_up_date: Yup.string().required("Next follow up date is required"),
      follow_up_remarks: Yup.string().nullable(),

      // EMD Details - emd_applicable toggle controls visibility, mode_of_emd and emd_amount required when applicable
      emd_applicable: Yup.boolean().default(false),
      mode_of_emd: Yup.string().when("emd_applicable", {
        is: true,
        then: (schema) => schema.required("Mode of EMD is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      emd_amount: Yup.number()
        .typeError("EMD Amount must be a number")
        .min(0, "EMD Amount cannot be negative")
        .when("emd_applicable", {
          is: true,
          then: (schema) => schema.required("EMD Amount is required"),
          otherwise: (schema) => schema.nullable(),
        }),

      // Attachment Description
      attachment_description: Yup.string().nullable(),
    });

    // Helper function to get current date in YYYY-MM-DD format
    const getCurrentDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const DEFAULT_ORGANISATION = {
      organization_id: "4f2e3a6c-5c4c-4445-92b6-6f64a26b1c78",
      organization_name: "MECORD SYSTEMS & SERVICES PVT. LTD.",
      org_address: "HILLVIEW INDUSTRIAL ESTATE, 304, off Lal Bahadur Shastri Marg, Amrut Nagar, Ghatkopar-W.",
      org_city: "Mumbai",
      org_state: "Maharashtra",
      org_country: "India",
      org_pincode: 400086,
      address: "HILLVIEW INDUSTRIAL ESTATE, 304, off Lal Bahadur Shastri Marg, Amrut Nagar, Ghatkopar-W.",
      city: "Mumbai",
      state: "Maharashtra",
      country: "India",
      pin_code: "400086"
    };

    // FORMIK
    const formik = useFormik<SalesOrderDataRetrive>({
      initialValues: {
        ...initialSalesOrderData,
        srv_date: initialSalesOrderData.srv_date || getCurrentDate(),
        currency_code: initialSalesOrderData.currency_code || "INR",
        exchange_rate: (initialSalesOrderData.currency_code === "INR" || initialSalesOrderData.currency_code === "IND" || !initialSalesOrderData.currency_code)
          ? "1"
          : (initialSalesOrderData.exchange_rate || ""),
        bill_from_address: initialSalesOrderData.bill_from_address || DEFAULT_ORGANISATION,
      },
      validationSchema: validationSchema,
      validateOnChange: false,
      validateOnBlur: false,
      validateOnMount: false,
      onSubmit: async (values, { setSubmitting }) => {
        try {
          await handleSubmitAction(values, "save"); // Always "save" for submit
          // toast.success("Sales order saved successfully");
          // navigate(`/sales-order/service/sales_order_log`);
        } catch (err) {
          // Error is already handled in handleSubmitAction
          // Don't navigate on error
        } finally {
          setSubmitting(false);
        }
      },
    });

    useScrollToFormikError(formik.errors, formik.submitCount + validationAttemptCount);

    const totals = useQuotationCalculations(
      items,
      "sales_order",
      formik?.values?.bill_from_address,
      shippingAddresses,
      formik
    );

    // Currency DropDown
    useEffect(() => {
      const fetchCurrency = async () => {
        try {
          const res = await Axios.get(`masters/currency/dropdown`);
          // console.log("Fetched dropdown:", res);
          const mappedCurrencyList = res.data?.data.map((item: any) => ({
            label: `${item.currency_name} (${item.currency_code})`,
            value: item.currency_code,
            currency_id: item.currency_id,
            currency_name: item.currency_name,
            currency_symbol: item.currency_symbol,
          }));

          setCurrencyList(mappedCurrencyList);

          // Sync currency code and symbol
          const currentCurrencyCode = formik.values.currency_code;
          const currentCurrencySymbol = formik.values.currency_symbol;

          // If currency_symbol is foreign but currency_code is still "INR", find and sync the correct currency_code
          if (currentCurrencySymbol && currentCurrencySymbol !== "₹" && (currentCurrencyCode === "INR" || currentCurrencyCode === "IND" || !currentCurrencyCode)) {
            const matchingCurrency = mappedCurrencyList.find(
              (c: any) => c.currency_symbol === currentCurrencySymbol
            );
            if (matchingCurrency) {
              formik.setFieldValue("currency_code", matchingCurrency.value);
            }
          }

          // Set currency symbol if currency_code is already set but symbol is missing
          if (currentCurrencyCode && !currentCurrencySymbol) {
            const selectedCurrency = mappedCurrencyList.find(
              (c: any) => c.value === currentCurrencyCode || c.value === "INR"
            );
            if (selectedCurrency) {
              formik.setFieldValue("currency_symbol", selectedCurrency.currency_symbol);
            } else if (currentCurrencyCode === "INR" || currentCurrencyCode === "IND") {
              formik.setFieldValue("currency_symbol", "₹");
            }
          }
        } catch (err) {
          console.error("Failed to fetch currency list:", err);
        }
      };

      fetchCurrency();
    }, [dispatch]);

    // Fetch GST Dropdown
    useEffect(() => {
      const fetchGST = async () => {
        try {
          const res = await Axios.get(`masters/gst/dropdown`);

          // console.log("Mapped", mappedCurrencyList);
          setCompositionList(res?.data?.data || res.data);
        } catch (err) {
          console.error("Failed to fetch currency list:", err);
        }
      };

      fetchGST();
    }, [dispatch]);

    // Fetch Technician Dropdown
    useEffect(() => {
      const fetchTechnician = async () => {
        try {
          const res = await dispatch(fetchTechnicianDropdown("Technician")).unwrap();
          // console.log("Fetched Technician dropdown:", res);
          setTechnicianOptions(res?.data?.data || res.data || res);
        } catch (err) {
          console.error("Failed to fetch Technician list:", err);
        }
      };

      fetchTechnician();
    }, [dispatch]);

    // Fetch service quotation dropdown data
    useEffect(() => {
      const fetchQuotationReferences = async () => {
        try {
          const qrefs = await dispatch(
            fetchServiceSalesOrderDropdownForQuotationNumber()
          ).unwrap();
          setQuotationReferences(qrefs?.data || qrefs);
        } catch (err) {
          console.error("Failed to load service quotation references:", err);
        }
      };

      fetchQuotationReferences();
    }, [dispatch]);

    // Reactively update shipping addresses and contact details when companies data changes (e.g. after adding a new address or contact)
    useEffect(() => {
      if (formik.values.company && companies.length > 0) {
        const currentCompanyId = formik.values.company.company_id || formik.values.company.id;
        const updatedCompany = companies.find((c) => c.id === currentCompanyId);

        if (updatedCompany) {
          // Update shipping addresses
          if (updatedCompany.shipping_addresses) {
            const formattedAddresses = updatedCompany.shipping_addresses.map(
              (addr: any) => ({
                id: addr.id || addr.shipping_address_id,
                address:
                  addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
                state: addr.state,
                city: addr.city,
                pin_code: addr.pin_code || addr.pincode,
                phone_number: addr.phone_number,
                country: addr.country || "",
              })
            );

            if (JSON.stringify(formattedAddresses) !== JSON.stringify(shippingAddresses)) {
              setShippingAddresses(formattedAddresses);
            }
          }

          // Update contact details - transform all contacts from company to form format
          const masterContacts = (updatedCompany.contact_details || updatedCompany.contacts || []).map((contact: any) => ({
            id: contact.contact_id || contact.id || "",
            contact_id: contact.contact_id || contact.id || "",
            contact_person_name: contact.name || contact.contact_person_name || "",
            contact_person_email: contact.email || contact.contact_person_email || "",
            contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
            contact_person_designation: contact.designation || contact.contact_person_designation || "",
            contact_person_department: contact.contact_person_department || "",
          }));

          // Merge with existing contacts in formik (which might have come from quotation)
          // Master contacts are prioritized/shown first
          const existingContacts = formik.values.company?.contact_details || [];
          const mergedContacts = [...masterContacts];

          existingContacts.forEach((exc: any) => {
            const alreadyPresent = mergedContacts.some(mc =>
              (mc.id && exc.id && mc.id === exc.id) ||
              (mc.contact_id && exc.contact_id && mc.contact_id === exc.contact_id) ||
              (mc.contact_person_email && exc.contact_person_email && mc.contact_person_email.toLowerCase() === exc.contact_person_email.toLowerCase())
            );
            if (!alreadyPresent) {
              mergedContacts.push(exc);
            }
          });

          // Update company object with merged contacts so dropdown shows all available contacts
          const updatedCompanyForForm = {
            ...formik.values.company,
            contact_details: mergedContacts,
          };

          // Only update if actually changed to avoid unnecessary re-renders
          if (JSON.stringify(mergedContacts) !== JSON.stringify(formik.values.company?.contact_details)) {
            formik.setFieldValue("company", updatedCompanyForForm, false); // Update reference to avoid stale data
          }
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companies, formik.values.company?.id, formik.values.company?.company_id]);

    // Sync selectedMemberIds with formik.values.members
    useEffect(() => {
      const memberIds = (formik.values.members || []).map((m: any) => m.id || m.user_id).filter(Boolean);
      setSelectedMemberIds(memberIds);
    }, [formik.values.members]);

    // Handler for adding a member
    const handleMemberAdd = (user: any) => {
      const userId = user.user_id || user.id;
      if (!selectedMemberIds.includes(userId)) {
        setSelectedMemberIds([...selectedMemberIds, userId]);
        const newMember = {
          id: userId,
          name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.username || user.email || "",
          initials: getInitials(user.first_name || "", user.last_name || ""),
        };
        formik.setFieldValue("members", [...(formik.values.members || []), newMember]);
      }
    };

    // Handler for removing a member
    const handleMemberRemove = (memberId: string) => {
      setSelectedMemberIds(selectedMemberIds.filter((id) => id !== memberId));
      formik.setFieldValue(
        "members",
        (formik.values.members || []).filter((m: any) => (m.id || m.user_id) !== memberId)
      );
    };

    // Sync selectedTechnicianIds with formik.values.technicians
    useEffect(() => {
      const technicianIds = (Array.isArray(formik.values.technicians) ? formik.values.technicians : []).map((t: any) => t.id || t.user_id).filter(Boolean);
      setSelectedTechnicianIds(technicianIds);
    }, [formik.values.technicians]);

    // Handler for adding a technician
    const handleTechnicianAdd = (tech: any) => {
      const techId = tech.user_id || tech.id;
      if (!selectedTechnicianIds.includes(techId)) {
        setSelectedTechnicianIds([...selectedTechnicianIds, techId]);
        const newTechnician = {
          ...tech, // Preserve all fields from technician object
          id: techId,
          user_id: tech.user_id || techId,
          name: tech.full_name || tech.fullname || `${tech.first_name || ""} ${tech.last_name || ""}`.trim() || tech.username || "",
          initials: getInitials(tech.first_name || "", tech.last_name || ""),
        };
        const updatedTechnicians = [...(Array.isArray(formik.values.technicians) ? formik.values.technicians : []), newTechnician];
        formik.setFieldValue("technicians", updatedTechnicians);
        formik.setFieldTouched("technicians", true, false);
        // Defer clear so it runs after Formik state + validateOnChange
        setTimeout(() => formik.setFieldError("technicians", undefined), 0);

      }
    };

    // Handler for removing a technician
    const handleTechnicianRemove = (technicianId: string) => {
      setSelectedTechnicianIds(selectedTechnicianIds.filter((id) => id !== technicianId));
      const updatedTechnicians = (Array.isArray(formik.values.technicians) ? formik.values.technicians : []).filter((t: any) => (t.id || t.user_id) !== technicianId);
      formik.setFieldValue("technicians", updatedTechnicians, true);
      // Mark field as touched and validate to update error state
      formik.setFieldTouched("technicians", true, false);
      formik.validateField("technicians");

    };

    // Sync calculated totals to formik values so they're included in the payload
    // Use ref to track previous totals to prevent unnecessary updates
    const prevTotalsRef = useRef<any>(null);
    useEffect(() => {
      if (totals && formik) {
        // Only update if totals have actually changed
        const totalsChanged =
          !prevTotalsRef.current ||
          prevTotalsRef.current.subTotal !== totals.subTotal ||
          prevTotalsRef.current.discount !== totals.discount ||
          prevTotalsRef.current.gst !== totals.gst ||
          prevTotalsRef.current.netTotal !== totals.netTotal ||
          prevTotalsRef.current.grandTotal !== totals.grandTotal ||
          prevTotalsRef.current.combinedGrandTotal !== totals.combinedGrandTotal ||
          prevTotalsRef.current.accessoryGrandTotal !== totals.accessoryGrandTotal;

        if (totalsChanged) {
          // Persist COMBINED totals (service + accessories) to API header fields
          formik.setFieldValue("subtotal_before_discount", (totals.combinedSubTotal ?? totals.subTotal).toString(), false);
          formik.setFieldValue("total_item_discounts", (totals.combinedDiscount ?? totals.discount).toString(), false);
          formik.setFieldValue("total_gst", (totals.combinedGst ?? totals.gst).toString(), false);
          formik.setFieldValue("net_taxable_value", (totals.combinedNetTotal ?? totals.netTotal).toString(), false);
          formik.setFieldValue("total_amount", (totals.combinedGrandTotal ?? totals.grandTotal).toString(), false);
          formik.setFieldValue("total_gst_value", (totals.combinedGst ?? totals.gst).toString(), false);
          prevTotalsRef.current = { ...totals };
        }
      }
    }, [totals?.subTotal, totals?.discount, totals?.gst, totals?.netTotal, totals?.grandTotal, totals?.combinedGrandTotal, totals?.accessoryGrandTotal, totals?.combinedSubTotal, totals?.combinedDiscount, totals?.combinedNetTotal, totals?.combinedGst]);

    // useEffect(() => {
    //   console.log("Formik Values:", formik.values);
    //   console.log("Formik Errors:", formik.errors);
    //   console.log("Formik Touched:", formik.touched);
    // }, [formik.values, formik.errors, formik.touched]);

    // Handler for adding items from ProductAndServiceSection
    const handleProductAdd = (item: any) => {
      // console.log("item in handleProductAdd: ", item);

      // Check for duplicate items
      setItems((prevItems) => {
        // Check if item with same item ID already exists
        const isDuplicateById = prevItems.some(
          (existingItem) => existingItem.item && existingItem.item === item.item
        );

        // Check if item with same item_name already exists (for products/services)
        const itemName =  item.serviceName;
        const isDuplicateByName = prevItems.some((existingItem) => {
          const existingItemName =
                existingItem.serviceName;
          return (
            existingItemName &&
            existingItemName.toLowerCase() === itemName?.toLowerCase()
          );
        });

        if (isDuplicateById || isDuplicateByName) {
          toast.error(
            "This item is already added. Please select a different item."
          );
          return prevItems; // Don't add the duplicate item
        }

        // If no duplicate, add the item
        return [...prevItems, item];
      });
    };

    const handleQuotationSelect = async (quotationId: string) => {
      try {
        const resData = await dispatch(
          fetchServiceQuotationById(quotationId)
        ).unwrap();
        // console.log("resData in line 543", resData)
        setQuotationData(resData?.data?.data || resData?.data || resData); // Set the form data
      } catch (err) {
        console.error("Failed to fetch service quotation data by reference:", err);
        toast.error("Failed to load quotation data.");
        setQuotationData(null); // Reset form on failure
      }
    };

    // Handle UID number generation
    const handleGenerateUid = async () => {
      setIsGeneratingUid(true);
      try {
        const response = await Axios.get('/order/uid-number/generate');
        if (response.data.success && response.data.data) {
          formik.setFieldValue('uid_number', response.data.data);
        }
      } catch (error: any) {
        console.error('Error generating UID number:', error);
        toast.error('Failed to generate UID number');
      } finally {
        setIsGeneratingUid(false);
      }
    };

    // Handle UID number clear
    const handleClearUid = () => {
      formik.setFieldValue('uid_number', '');
    };

    const hasUidNumber = formik.values.uid_number && formik.values.uid_number.trim() !== '';

    // mapped item details
    const mapQuotationItemToFormItem = (item: any) => {
      // Convert numeric strings to actual numbers for easier calculation in the UI
      const toNum = (value: any) => (value ? Number(value) : 0);
      const roundToTwoDecimals = (num: number): number => {
        return Math.round(num * 100) / 100;
      };

      // Calculate discount fields before creating the return object
      const rawDiscountType = (item.discount_type || "").toString().trim().toLowerCase();
      const isPercentage = rawDiscountType === "%" || rawDiscountType === "percentage" || rawDiscountType === "percent";
      const discountType = isPercentage ? "%" : (item.discount_type || "₹");
      const discountValue = toNum(item.discount_value || item.discount || 0);
      const quantity = toNum(item.product_quantity || item.quantity || 1);
      const unitPrice = toNum(item.unit_price);
      const serviceRate = toNum(item.service_rate || item.unit_price);
      const grossValue = toNum(item.gross_value || (serviceRate * quantity));

      // Calculate discount_amount based on discount_type
      let discountAmount = 0;
      if (isPercentage && discountValue > 0) {
        discountAmount = grossValue > 0 ? roundToTwoDecimals((grossValue * discountValue) / 100) : 0;
      } else if (!isPercentage && discountValue > 0) {
        discountAmount = roundToTwoDecimals(discountValue);
      }

      const serialNumber = item.serial_number || item.serial_no || item.serialNo || "";

      return {
        // Core Identifiers and Names
        id: item.quotation_service_item_id || item.id,
        quotation_service_item_id: item.quotation_service_item_id || null,
        item_name: item.product_name || item.item_name,
        item_type: "services", // Service quotation items
        category_name: item.category_name,
        sub_category_name: item.sub_category_name,
        make_name: item.make_name,
        model_name: item.model_name,

        // Financials (Converted to Number for better UI interaction)
        quantity: quantity,
        unit_price: unitPrice,

        // Service-specific fields
        serviceRate: serviceRate,
        productQuantity: quantity,

        // Discount fields
        discount: discountValue,
        discount_type: discountType,
        discount_value: discountValue,
        discount_percent: isPercentage ? discountValue : null,
        discount_amount: discountAmount,
        gross_value: grossValue,

        net_value: toNum(item.total_service_net_amount || item.net_value || (grossValue - discountAmount)),

        // GST/Tax Details
        gst_percent: toNum(item.gst_percentage || 0),
        gst_percentage: toNum(item.gst_percentage || 0),
        gst_value: toNum(item.gst_value || 0),
        original_gst_value: toNum(item.gst_value || 0),
        original_gst_percent: toNum(item.gst_percentage || 0),
        ...(() => {
          const rawGst = toNum(item.gst_percentage || 0);
          const isComp =
            quotationData?.composition_gst ||
            quotationData?.customer_details?.gst_type === "Compositional gst" ||
            initialData?.composition_gst ||
            initialData?.customer_details?.gst_type === "Compositional gst";

          if (isComp || rawGst <= 0) {
            return { cgst_percent: 0, sgst_percent: 0, igst_percent: 0 };
          }

          // Check intra-state (same state -> CGST + SGST, different state -> IGST)
          const billFrom =
            quotationData?.bill_from || initialData?.bill_from || {};
          const billFromState = (
            billFrom.org_state ||
            billFrom.state ||
            "maharashtra"
          )
            .toString()
            .trim()
            .toLowerCase();

          const custDetails =
            quotationData?.customer_details ||
            initialData?.customer_details ||
            {};
          const billingAddr =
            custDetails.billing_address || custDetails.billingAddress || {};
          const billToState = (
            billingAddr.state ||
            custDetails.state ||
            ""
          )
            .toString()
            .trim()
            .toLowerCase();

          const isIntra =
            !!billToState && !!billFromState && billFromState === billToState;

          if (isIntra) {
            return {
              cgst_percent: roundToTwoDecimals(rawGst / 2),
              sgst_percent: roundToTwoDecimals(rawGst / 2),
              igst_percent: 0,
            };
          } else {
            return {
              cgst_percent: 0,
              sgst_percent: 0,
              igst_percent: rawGst,
            };
          }
        })(),
        gst_amount: toNum(item.gst_value || 0),

        total_amount: toNum(item.total_service_amount || item.total_price),
        total_price: toNum(item.total_service_amount || item.total_price),

        // Service-specific fields
        serviceCategory: item.service_category || "",
        serviceMethod: item.service_method || "",
        serviceType: item.service_type || "",
        executionMode: item.execution_mode || "",
        serialNo: serialNumber,
        serial_no: serialNumber,
        serial_number: serialNumber,
        reportedComplaint: item.reported_complaints || "",
        sac_code: item.sac_code || "",
        sac_code_id: item.sac_code_id || item.sac_id || "",

        // Serviceability
        is_serviceable: item.serviceable || true,

        // Additional fields
        product_sku: item.product_sku || "",
        hsn_code: item.hsn_code || "",
        unit_name: item.unit_name || "",

        // Foreign Keys (UUIDs) - Keep as strings
        item: item.product_id || item.item,
        category: item.category_name,
        sub_category: item.sub_category_name,
        make: item.make_name,
        model: item.model_name,

        // Shipping Address - handle service quotation format
        shipping_address_id: (() => {
          // For service quotations, shipping_address might be an array
          if (item.shipping_address && Array.isArray(item.shipping_address) && item.shipping_address.length > 0) {
            // If it's an array, get the first item's ID
            const firstAddr = item.shipping_address[0];
            return firstAddr?.shipping_address_id || firstAddr?.id || null;
          }
          // Fallback to existing logic
          if (item.shipping_address_id) {
            return item.shipping_address_id;
          }
          if (item.shipping_id) {
            return item.shipping_id;
          }
          if (
            item.shipping_address &&
            typeof item.shipping_address === "object" &&
            !Array.isArray(item.shipping_address)
          ) {
            // Handle object case - extract ID
            return item.shipping_address.shipping_address_id || item.shipping_address.id || null;
          }
          return null;
        })(),
        // Preserve full shipping_address object for payload builder
        shipping_address: (() => {
          // For service quotations, shipping_address might be an array
          if (item.shipping_address && Array.isArray(item.shipping_address) && item.shipping_address.length > 0) {
            // If it's an array, use the first item
            const firstAddr = item.shipping_address[0];
            return {
              shipping_address_id: firstAddr?.shipping_address_id || firstAddr?.id || "",
              address: firstAddr?.address || "",
              city: firstAddr?.city || "",
              state: firstAddr?.state || "",
              country: firstAddr?.country || "",
              pin_code: firstAddr?.pin_code || firstAddr?.pincode || "",
              phone_number: firstAddr?.phone_number || "",
            };
          }
          // Handle object case
          if (item.shipping_address && typeof item.shipping_address === "object" && !Array.isArray(item.shipping_address)) {
            return {
              shipping_address_id: item.shipping_address.shipping_address_id || item.shipping_address.id || "",
              address: item.shipping_address.address || "",
              city: item.shipping_address.city || "",
              state: item.shipping_address.state || "",
              country: item.shipping_address.country || "",
              pin_code: item.shipping_address.pin_code || item.shipping_address.pincode || "",
              phone_number: item.shipping_address.phone_number || "",
            };
          }
          return null;
        })(),
        // Service Address - format for display in UI (matching ServiceSection format)
        serviceAddress: (() => {
          // For service quotations, shipping_address might be an array
          if (item.shipping_address && Array.isArray(item.shipping_address) && item.shipping_address.length > 0) {
            // If it's an array, format the first item
            const firstAddr = item.shipping_address[0];
            if (firstAddr && typeof firstAddr === "object" && firstAddr.address) {
              // Format: "address, city, state, country - pincode" (matching ServiceSection format)
              const addressParts = [
                firstAddr.address,
                firstAddr.city,
                firstAddr.state,
                firstAddr.country
              ].filter(Boolean);
              const pincode = firstAddr.pincode || firstAddr.pin_code;
              if (addressParts.length > 0) {
                return pincode ? `${addressParts.join(", ")} - ${pincode}` : addressParts.join(", ");
              }
            }
            // If it's just an address string in the array
            if (typeof firstAddr === "string") {
              return firstAddr;
            }
            // If it's an object with just address property
            if (firstAddr && firstAddr.address) {
              return firstAddr.address;
            }
            return "";
          }
          // Handle object case (most common for quotation items)
          if (
            item.shipping_address &&
            typeof item.shipping_address === "object" &&
            !Array.isArray(item.shipping_address)
          ) {
            const addr = item.shipping_address;
            if (addr.address) {
              // Format: "address, city, state, country - pincode" (matching ServiceSection format)
              const addressParts = [
                addr.address,
                addr.city,
                addr.state,
                addr.country
              ].filter(Boolean);
              const pincode = addr.pincode || addr.pin_code;
              if (addressParts.length > 0) {
                return pincode ? `${addressParts.join(", ")} - ${pincode}` : addressParts.join(", ");
              }
            }
            return "";
          }
          return "";
        })(),

        prod_description: item.prod_description ?? item.description ?? "",
        additional_details: item.additional_details ?? "",

        // Additional fields not in your interface but might be useful
        product_quotation: item.product_quotation || null,
        service_quotation: item.service_quotation || null,
        accessories: Array.isArray(item.accessories)
          ? item.accessories
              .filter((acc: any) => !acc?.is_deleted)
              .map((acc: any) => {
                // Already UI-shaped from transform, or API-shaped from quotation
                if (
                  acc.temp_id &&
                  (acc.discount_type === "percentage" ||
                    acc.discount_type === "currency")
                ) {
                  return acc;
                }
                const discountTypeRaw = (acc.discount_type || "").toString();
                const isPercentage =
                  discountTypeRaw === "%" ||
                  discountTypeRaw.toLowerCase() === "percentage" ||
                  discountTypeRaw.toLowerCase() === "percent";
                const qty = Number(acc.quantity || 1);
                const rate = Number(acc.unit_price || 0);
                const gross = Number(acc.gross_value ?? qty * rate);
                const discVal = Number(acc.discount_value || 0);
                const discAmt = Number(
                  acc.discount_amount ??
                    (isPercentage ? (gross * discVal) / 100 : discVal)
                );
                const taxable = Number(acc.taxable_amount ?? gross - discAmt);
                const gstPct = Number(acc.gst_percentage || 0);
                const gstVal = Number(acc.gst_value ?? (taxable * gstPct) / 100);
                const isComp =
                  quotationData?.composition_gst ||
                  quotationData?.customer_details?.gst_type === "Compositional gst" ||
                  initialData?.composition_gst ||
                  initialData?.customer_details?.gst_type === "Compositional gst";

                const billFrom =
                  quotationData?.bill_from || initialData?.bill_from || {};
                const billFromState = (
                  billFrom.org_state ||
                  billFrom.state ||
                  "maharashtra"
                )
                  .toString()
                  .trim()
                  .toLowerCase();

                const custDetails =
                  quotationData?.customer_details ||
                  initialData?.customer_details ||
                  {};
                const billingAddr =
                  custDetails.billing_address || custDetails.billingAddress || {};
                const billToState = (
                  billingAddr.state ||
                  custDetails.state ||
                  ""
                )
                  .toString()
                  .trim()
                  .toLowerCase();

                const isIntra =
                  !!billToState && !!billFromState && billFromState === billToState;

                const effectiveGstPct = isComp ? 0 : gstPct;
                const effectiveCgst = isComp ? 0 : isIntra ? roundToTwoDecimals(effectiveGstPct / 2) : 0;
                const effectiveSgst = isComp ? 0 : isIntra ? roundToTwoDecimals(effectiveGstPct / 2) : 0;
                const effectiveIgst = isComp ? 0 : !isIntra ? effectiveGstPct : 0;

                return {
                  temp_id: acc.accessory_id || `acc-${acc.product_id}-${Math.random().toString(36).slice(2, 7)}`,
                  accessory_id: acc.accessory_id,
                  product_id: acc.product_id,
                  product_name: acc.product_name || "",
                  product_sku: acc.product_sku || "",
                  category_name: acc.category_name || "",
                  sub_category_name: acc.sub_category_name || "",
                  make_name: acc.make_name || "",
                  model_name: acc.model_name || "",
                  unit_name: acc.unit_name || "Nos",
                  hsn_code: acc.hsn_code || "",
                  quantity: qty,
                  unit_price: rate,
                  discount_type: isPercentage ? "percentage" : "currency",
                  discount_value: discVal,
                  gst_percentage: effectiveGstPct,
                  cgst_percentage: Number(acc.cgst_percentage || effectiveCgst),
                  sgst_percentage: Number(acc.sgst_percentage || effectiveSgst),
                  igst_percentage: Number(acc.igst_percentage || effectiveIgst),
                  remark: acc.remark || "",
                  gross_value: Math.round(gross * 100) / 100,
                  discount_amount: Math.round(discAmt * 100) / 100,
                  taxable_amount: Math.round(taxable * 100) / 100,
                  gst_value: Math.round(gstVal * 100) / 100,
                  total_amount: Math.round(Number(acc.total_amount ?? taxable + gstVal) * 100) / 100,
                };
              })
          : [],
      };
    };

    const mapDataToForm = (
      data: any,
      isSalesOrder = false,
      isEditMode = false
    ) => {
      const details = data;
      // console.log("mapping details in sales order: ", details, isSalesOrder);
      // console.log("bill_from_address from API:", details?.bill_from_address);
      // console.log("bill_from from API:", details?.bill_from);
      // console.log("organizationsState:", organizationsState);

      // SCENARIO: Get the company ID from the API data.
      // The API returns the company ID directly in 'details.company'
      const companyIdFromApi = details.company;

      // FIX 1: Find the full company object from the props array using the ID.
      // This full object is necessary for the Autocomplete component.
      const companyObj = companies.find((c) => c.id === companyIdFromApi) || null;
      // console.log("companyObj : ", companyObj);

      // Extract shipping addresses from the company object
      if (companyObj?.shipping_addresses) {
        const formattedAddresses = companyObj.shipping_addresses.map(
          (addr: any) => ({
            id: addr.id,
            address:
              addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
            state: addr.state,
            city: addr.city,
            pin_code: addr.pin_code,
          })
        );
        setShippingAddresses(formattedAddresses);
        // console.log("Set shippingAddresses from company:", formattedAddresses);
      }

      // Also check if items have shipping_address objects that need to be added
      const itemShippingAddresses: any[] = [];
      (details?.item_details || []).forEach((item: any) => {
        if (
          item.shipping_address &&
          typeof item.shipping_address === "object" &&
          Object.keys(item.shipping_address).length > 0
        ) {
          const shippingAddr = item.shipping_address as any;
          if (
            shippingAddr.id &&
            !itemShippingAddresses.find((addr) => addr.id === shippingAddr.id)
          ) {
            itemShippingAddresses.push({
              id: shippingAddr.id,
              address:
                shippingAddr.address ||
                `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
              state: shippingAddr.state,
              city: shippingAddr.city,
              pin_code: shippingAddr.pin_code,
            });
          }
        }
      });

      // Add item shipping addresses to the state if they don't already exist
      if (itemShippingAddresses.length > 0) {
        setShippingAddresses((prev) => {
          const newAddresses = [...prev];
          itemShippingAddresses.forEach((addr) => {
            if (!newAddresses.find((a) => a.id === addr.id)) {
              newAddresses.push(addr);
            }
          });
          // console.log("Added item shipping addresses:", itemShippingAddresses);
          // console.log("Final shippingAddresses:", newAddresses);
          return newAddresses;
        });
      }

      // FIX 2: Find the contact person object within the full company object.
      // We match by the contact_person_name returned at the top level of the API response.
      // const organizationObj = organizationsState.find(org => org.id === details.organization);
      const contact =
        (companyObj?.contact_details || []).find(
          (c: any) => c.contact_person_name === details.contact_person_name
        ) || null;

      // FIX 3: Map the API's agent object structure to the expected Agent interface.
      // The API uses agent_name, agent_designation, etc.
      const agentData = details.agent
        ? {
          agent_name: details?.agent.agent_name || "N/A",
          agent_designation: details?.agent.agent_designation || "",
          agent_department: details?.agent.agent_department || "",
        }
        : null;

      // quotation obj filter - find and set the quotation object
      // Use details?.id when creating from quotation, details?.quotation when editing sales order
      const quotationId = details?.quotation || details?.id;
      if (quotationId) {
        // If user is actively selecting, don't override their selection
        if (
          isUserSelectingQuotation.current &&
          selectedQuotation &&
          selectedQuotation.id === quotationId
        ) {
          // User selection matches loaded data, preserve it and reset flag
          isUserSelectingQuotation.current = false;
        } else if (
          !isUserSelectingQuotation.current &&
          quotationReferences &&
          Array.isArray(quotationReferences)
        ) {
          // Not a user selection, find and set from loaded data
          const quotationOBJ = quotationReferences.find(
            (q: any) => q.id === quotationId
          );
          // console.log(
          //   "quotationOBJ : ",
          //   quotationOBJ,
          //   "quotationId:",
          //   quotationId,
          //   "quotationReferences:",
          //   quotationReferences
          // );
          if (quotationOBJ) {
            setSelectedQuotation(quotationOBJ);
          }
        }
      }
      // FIX 4: Map Assigned Members
      const assignedMembersFromApi = details.assigned_member_details || [];
      // If the API returns full member objects, use them directly.
      // If it returns simple {id: '...', name: '...'} and your 'membersOptions' are fuller, you'd need to map those.
      // Based on the console log, the objects look rich enough to be used directly if they match the option structure.
      const mappedMembers = assignedMembersFromApi.map(
        (member: any) =>
          // We ensure the object structure matches what 'membersOptions' provides,
          // specifically for the Autocomplete to find the full object to display the name.
          // Assuming membersOptions are full user/member objects.
          membersOptions.find(
            (m: any) => m.id === member.id || m.id === member.user
          ) || member
      );

      // console.log("mappedMembers : ", mappedMembers);
      const itemDetails = details?.item_details || [];
      // console.log("isEditMode : ", isEditMode);
      formik.setValues((prev: any) => ({
        ...prev,

        // QUOTATION-SPECIFIC FIELDS (Autofill only on Edit, or leave blank/user-input)
        quotation_number: details?.quotation_number || "",
        quotation: isEdit ? details?.quotation : details?.id,
        enquiry: details?.enquiry || "",
        schedule_service_date: details?.schedule_service_date || "",
        billing_address: details?.billing_address,
        shipping_address: details?.shipping_address,
        sales_order: isEdit ? details?.id : "",
        sales_srv_date: "",
        valid_until: "",
        initiated_by: details?.initiated_by || "", // Use initiated_by from your API
        terms_and_conditions:  [],
        notes: "",
        next_follow_up_date:
          (details?.next_follow_up_date || details?.next_followup_date || "").split?.("T")?.[0] ||
          (details?.next_follow_up_date || details?.next_followup_date || ""),
        follow_up_remarks: details?.follow_up_remarks || details?.remarks || "",
        retention_details: {
          retention_applicable: !!(
            details?.retention_details?.retention_applicable ??
            details?.retention_details?.is_applicable ??
            details?.retention_details?.retentionType ??
            details?.retention_details?.retention_type ??
            details?.retention_details?.percentage ??
            details?.retention_details?.retention_percentage ??
            details?.retention_details?.retentionAmount ??
            details?.retention_details?.retention_amount ??
            details?.retention_details?.followUpDate ??
            details?.retention_details?.next_follow_up_date
          ),
          retentionType:
            details?.retention_details?.retentionType ||
            details?.retention_details?.retention_type ||
            "",
          percentage:
            details?.retention_details?.percentage ??
            details?.retention_details?.retention_percentage ??
            "",
          retentionAmount:
            details?.retention_details?.retentionAmount ??
            details?.retention_details?.retention_amount ??
            "",
          followUpDate:
            details?.retention_details?.followUpDate ||
            details?.retention_details?.next_follow_up_date ||
            "",
        },
        subtotal_before_discount: details?.subtotal_before_discount || "",
        total_item_discounts: details?.total_item_discounts || "",
        net_total: details?.net_total || "",
        total_gst_value: details?.total_gst_value || "",
        grand_total_amount: details?.grand_total_amount || "",
        // Use the enquiry_number from API when creating from enquiry
        enquiry_number:
          details?.enquiry_reference || details?.enquiry_number || "",
        reference_number: details?.reference_number || "",

        // ENQUIRY DATA FIELDS (Autofill in all scenarios)
        source_of_quotation:
          details?.sourceOfEnquiry || details?.source_of_enquiry || null,

        // Map Company and Contact (using the objects found/created above)
        company: companyObj, // FIX: Full Company object
        company_name: companyObj?.company_name,
        industry: details.industry || companyObj?.industry || "",

        // PBG Section
        pbg_details: details?.pbg_details || initialPBGDetail,

        // Currency & Composition Section
        currency_code: details?.currency_code || "INR", // Default currency,
        currency_symbol: details?.currency_symbol || "₹", // Default currency symbol
        exchange_rate: details?.exchange_rate || "1",
        composition_gst: details?.composition_gst || false,
        select_composition_gst: details?.select_composition_gst || "",

        // Payment Terms
        payment_terms: details?.payment_terms || "",
        payment_terms_amount: details?.payment_terms_amount != null ? String(details.payment_terms_amount) : "",
        advance_payment: details?.advance_payment || "",
        pending_payment: details?.pending_payment || "",
        next_credit_schedule: details?.next_credit_schedule || null,
        payment_reminder: details?.payment_reminder || "",

        // Inspection & Installation section
        inspection: details?.inspection || "", // e.g., "Applicable" or "Not Applicable"
        inspection_date: details?.inspection_date || "", // required only if inspection === "Applicable"
        installation: details?.installation || "", // e.g., "Applicable" or "Not Applicable"
        installation_date: details?.installation_date || "", // required only if installation === "Applicable"

        // Bill Section
        bill_to: details?.bill_to || "",
        bill_from: details?.bill_from || "",
        bill_to_address: details?.billing_address || null,
        // Handle bill_from_address: if empty object, try to find from organizationsState, otherwise use the value or null
        bill_from_address: (() => {
          const billFromAddr = details?.bill_from_address;
          // console.log(
          //   "Processing bill_from_address:",
          //   billFromAddr,
          //   "Type:",
          //   typeof billFromAddr
          // );

          // Check if it's an empty object (no keys or all values are falsy)
          const isEmptyObject =
            billFromAddr &&
            typeof billFromAddr === "object" &&
            !Array.isArray(billFromAddr) &&
            Object.keys(billFromAddr).length === 0;

          // console.log("Is empty object?", isEmptyObject);

          if (isEmptyObject) {
            // console.log("bill_from ID:", details?.bill_from);
            // If bill_from ID exists, try to find the organization from organizationsState
            if (
              details?.bill_from &&
              organizationsState &&
              organizationsState.length > 0
            ) {
              const orgObj = organizationsState.find(
                (org: any) => org.id === details.bill_from
              );
              // console.log("Found organization:", orgObj);
              if (orgObj && orgObj.org_address) {
                // console.log("Returning org_address:", orgObj.org_address);
                return orgObj.org_address; // Return the address string
              }
            }
            // Return empty string if empty object and no organization found (for freeSolo Autocomplete)
            // console.log("Returning empty string for bill_from_address");
            return "";
          }

          // If it's a string, use it directly
          if (typeof billFromAddr === "string") {
            // console.log("bill_from_address is string:", billFromAddr);
            return billFromAddr;
          }

          // If it's an object with properties, check if it has org_address or construct from address fields
          if (
            billFromAddr &&
            typeof billFromAddr === "object" &&
            !Array.isArray(billFromAddr) &&
            Object.keys(billFromAddr).length > 0
          ) {
            // console.log(
            //   "bill_from_address is object with properties:",
            //   billFromAddr
            // );
            // If it has org_address, use it
            if (billFromAddr.org_address) {
              return billFromAddr.org_address;
            }
            // Otherwise, construct address string from individual fields
            if (billFromAddr.address || billFromAddr.city || billFromAddr.state) {
              const parts = [
                billFromAddr.address,
                billFromAddr.city,
                billFromAddr.state,
                billFromAddr.pin_code,
              ].filter(Boolean);
              const constructed = parts.length > 0 ? parts.join(", ") : "";
              // console.log("Constructed address:", constructed);
              return constructed;
            }
            // If object has properties but no address fields, return empty string
            return "";
          }

          // Default to empty string for freeSolo Autocomplete
          // console.log("Returning default empty string");
          return "";
        })(),
        // Autofill individual contact fields directly from the API response
        contactPerson: contact, // FIX: Full Contact object for Autocomplete
        contactPersonArray: details?.contactPersonArray || [],
        contact_person_name:
          details.contact_person_name || contact?.contact_person_name || "",
        contact_person_designation:
          details.contact_person_designation ||
          contact?.contact_person_designation ||
          "",
        contact_person_phone_no:
          details.contact_person_phone_no ||
          contact?.contact_person_phone_no ||
          "",
        contact_person_email:
          details.contact_person_email || contact?.contact_person_email || "",


        // Map Agent (using the object created above)
        // agent: agentData, // FIX: Mapped Agent object for Autocomplete
        // designation: agentData?.agent_designation || "",
        // department: agentData?.agent_department || "",
        // emd: details.emd || "",
        agent_name: details.agent_name || "",
        // Map Assigned Members
        members: mappedMembers, // FIX: Mapped Array of Member objects
      }));

      // Map Item Details
      // Get current shipping addresses from companyObj (not state, as state updates are async)
      const currentShippingAddresses = companyObj?.shipping_addresses || [];

      // Collect all shipping addresses from items that need to be added
      const itemShippingAddressesToAdd: any[] = [];

      const mappedItemDetails = (details?.item_details || []).map((item: any) => {
        const mappedItem = mapQuotationItemToFormItem(item);

        // console.log(
        //   "Mapping item:",
        //   item.id,
        //   "shipping_address_id:",
        //   mappedItem.shipping_address_id,
        //   "shipping_address:",
        //   item.shipping_address,
        //   "shipping_id:",
        //   item.shipping_id
        // );

        // If shipping_address_id exists, check if it's in company addresses
        if (mappedItem.shipping_address_id) {
          const addrExists = currentShippingAddresses.find(
            (addr: any) => addr.id === mappedItem.shipping_address_id
          );
          // console.log(
          //   "Address exists in company addresses?",
          //   !!addrExists,
          //   "for ID:",
          //   mappedItem.shipping_address_id
          // );

          // If not found in company addresses, check if item has shipping_address object with data
          if (
            !addrExists &&
            item.shipping_address &&
            typeof item.shipping_address === "object"
          ) {
            const shippingAddr = item.shipping_address as any;
            // Check if it's not an empty object
            if (Object.keys(shippingAddr).length > 0) {
              // If it has an ID, use it; otherwise try to match by address content
              if (shippingAddr.id) {
                // Add to list to be added to state
                if (
                  !itemShippingAddressesToAdd.find(
                    (addr) => addr.id === shippingAddr.id
                  )
                ) {
                  itemShippingAddressesToAdd.push({
                    id: shippingAddr.id,
                    address:
                      shippingAddr.address ||
                      `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
                    state: shippingAddr.state,
                    city: shippingAddr.city,
                    pin_code: shippingAddr.pin_code,
                  });
                }
              } else if (shippingAddr.address || shippingAddr.city) {
                // If no ID but has address data, try to find matching address in company addresses by content
                const matchingAddr = currentShippingAddresses.find(
                  (addr: any) =>
                    addr.address === shippingAddr.address ||
                    (addr.city === shippingAddr.city &&
                      addr.state === shippingAddr.state &&
                      addr.pin_code === shippingAddr.pin_code)
                );
                if (matchingAddr) {
                  // Update the mapped item with the matching address ID
                  mappedItem.shipping_address_id = matchingAddr.id;
                  // console.log(
                  //   "Matched shipping address by content, using ID:",
                  //   matchingAddr.id
                  // );
                }
              }
            }
          }
        } else {
          // If no shipping_address_id, try to find it from shipping_address object
          if (
            item.shipping_address &&
            typeof item.shipping_address === "object" &&
            Object.keys(item.shipping_address).length > 0
          ) {
            const shippingAddr = item.shipping_address as any;
            if (shippingAddr.id) {
              mappedItem.shipping_address_id = shippingAddr.id;
              // console.log(
              //   "Set shipping_address_id from shipping_address.id:",
              //   shippingAddr.id
              // );

              // Add to list if not in company addresses
              const addrExists = currentShippingAddresses.find(
                (addr: any) => addr.id === shippingAddr.id
              );
              if (
                !addrExists &&
                !itemShippingAddressesToAdd.find(
                  (addr) => addr.id === shippingAddr.id
                )
              ) {
                itemShippingAddressesToAdd.push({
                  id: shippingAddr.id,
                  address:
                    shippingAddr.address ||
                    `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
                  state: shippingAddr.state,
                  city: shippingAddr.city,
                  pin_code: shippingAddr.pin_code,
                });
              }
            }
          }
        }

        return mappedItem;
      });

      // Add item shipping addresses to state if any were found
      if (itemShippingAddressesToAdd.length > 0) {
        setShippingAddresses((prev) => {
          const newAddresses = [...prev];
          itemShippingAddressesToAdd.forEach((addr) => {
            if (!newAddresses.find((a) => a.id === addr.id)) {
              newAddresses.push(addr);
            }
          });
          // console.log(
          //   "Added item shipping addresses to state:",
          //   itemShippingAddressesToAdd
          // );
          return newAddresses;
        });
      }

      // console.log("itemDetails in quotation form: ", itemDetails);
      // console.log(
      //   "mappedItemDetails with shipping_address_id: ",
      //   mappedItemDetails
      // );
      // console.log("currentShippingAddresses: ", currentShippingAddresses);
      // console.log(
      //   "Final shippingAddresses state will include:",
      //   itemShippingAddressesToAdd
      // );
      setItems(mappedItemDetails);

      // Update the selected enquiry reference for SCENARIO 1 UI
      // if (!isQuotation) {
      // You might need to find the full reference object based on 'details.id'
      //   setSelectedEnquiry(
      //     enquiryReferences.find((r) => r.id === details.id) || null
      //   );
      // }
    };

    // ---- Autofill Logic (useEffect for quotationData) ----
    useEffect(() => {
      // Only load data if quotationData has actual data (not empty object)
      if (!quotationData || (!quotationData.id && !quotationData.quotation_service_id)) {
        return;
      }

      // console.log("Loading service quotation data:", quotationData);
      setLoading(true);

      try {
        // Create Sales Order from Service Quotation - data will be handled by formik initial values
        if (quotationData) {
          // console.log("Setting form values from service quotation data");

          // Extract customer details from quotation data
          const customerDetails = quotationData.customer_details || {};
          const companyIdFromQuotation = customerDetails.company_id || customerDetails.customer_id;

          // Find the full company object from the companies array
          const companyObj = companyIdFromQuotation
            ? companies.find((c) => c.id === companyIdFromQuotation || c.company_id === companyIdFromQuotation) || null
            : null;

          // Extract shipping addresses - check both company object and customer_details
          let formattedAddresses: any[] = [];

          // First, try to get from company object
          if (companyObj?.shipping_addresses && Array.isArray(companyObj.shipping_addresses)) {
            formattedAddresses = companyObj.shipping_addresses.map(
              (addr: any) => ({
                id: addr.id || addr.shipping_address_id,
                address: addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
                state: addr.state,
                city: addr.city,
                pin_code: addr.pincode || addr.pin_code,
                phone_number: addr.phone_number,
              })
            );
          }

          // If no addresses from company, try from customer_details.shipping_address
          if (formattedAddresses.length === 0 && customerDetails.shipping_address && Array.isArray(customerDetails.shipping_address)) {
            formattedAddresses = customerDetails.shipping_address.map(
              (addr: any) => ({
                id: addr.shipping_address_id || addr.id,
                address: addr.address || `${addr.city}, ${addr.state}, ${addr.pincode || addr.pin_code}`,
                state: addr.state,
                city: addr.city,
                pin_code: addr.pincode || addr.pin_code,
                phone_number: addr.phone_number,
              })
            );
          }

          setShippingAddresses(formattedAddresses);

          // Transform contacts from customer_details to form format
          const quotationContacts = (customerDetails.contact_details || customerDetails.contacts || []).map((contact: any) => ({
            id: contact.contact_id || contact.id || "",
            contact_id: contact.contact_id || contact.id || "",
            contact_person_name: contact.name || contact.contact_person_name || "",
            contact_person_email: contact.email || contact.contact_person_email || "",
            contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
            contact_person_designation: contact.designation || contact.contact_person_designation || "",
            contact_person_department: contact.contact_person_department || "",
          }));

          // Get ALL contacts from the company object (not just from quotation)
          const masterContacts = companyObj
            ? (companyObj.contact_details || companyObj.contacts || []).map((contact: any) => ({
              id: contact.contact_id || contact.id || "",
              contact_id: contact.contact_id || contact.id || "",
              contact_person_name: contact.name || contact.contact_person_name || "",
              contact_person_email: contact.email || contact.contact_person_email || "",
              contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
              contact_person_designation: contact.designation || contact.contact_person_designation || "",
              contact_person_department: contact.contact_person_department || "",
            }))
            : [];

          // Merge quotation contacts with master contacts
          const mergedContacts = [...masterContacts];
          quotationContacts.forEach((qc: any) => {
            const alreadyPresent = mergedContacts.some(mc =>
              (mc.id && qc.id && mc.id === qc.id) ||
              (mc.contact_id && qc.contact_id && mc.contact_id === qc.contact_id) ||
              (mc.contact_person_email && qc.contact_person_email && mc.contact_person_email.toLowerCase() === qc.contact_person_email.toLowerCase())
            );
            if (!alreadyPresent) {
              mergedContacts.push(qc);
            }
          });

          // Create company object with proper structure for autocomplete
          const companyForForm: any = companyObj ? {
            id: companyObj.id || companyObj.company_id,
            company_id: companyObj.company_id || companyObj.id,
            company_name: companyObj.company_name || customerDetails.company_name || customerDetails.customer_name || "",
            company_email: companyObj.company_email || customerDetails.company_email || customerDetails.email || "",
            vendor_code: companyObj.vendor_code || "",
            branch_name: companyObj.branch_name || "",
            industry: companyObj.industry || customerDetails.industry || "",
            industry_name: companyObj.industry || customerDetails.industry || "",
            contact_details: mergedContacts, // Use merged contacts
            gstin: companyObj.gstin || customerDetails.gstin || "",
            gst_type: companyObj.gst_type || customerDetails.gst_type || customerDetails.type || "",
            phone_number: companyObj.phone_number || customerDetails.phone_number || "",
            sr_no: companyObj.sr_no || 1,
            billing_address: companyObj.billing_address || customerDetails.billing_address,
            shipping_addresses: formattedAddresses.length > 0 ? formattedAddresses : (companyObj.shipping_addresses || []),
          } : (companyIdFromQuotation ? {
            id: companyIdFromQuotation,
            company_id: companyIdFromQuotation,
            company_name: customerDetails.company_name || customerDetails.customer_name || "",
            company_email: customerDetails.company_email || customerDetails.email || "",
             vendor_code: customerDetails.vendor_code || "",
            branch_name: customerDetails.branch_name || "",
            industry: customerDetails.industry || "",
            industry_name: customerDetails.industry || "",
            contact_details: quotationContacts,
            gstin: customerDetails.gstin || "",
            gst_type: customerDetails.gst_type || customerDetails.type || "",
            phone_number: customerDetails.phone_number || "",
            sr_no: 1,
            billing_address: customerDetails.billing_address,
            shipping_addresses: formattedAddresses,
          } : null);

          // Format billing address properly
          const billingAddress = customerDetails.billing_address || companyObj?.billing_address || {};
          const formattedBillingAddress = {
            address: billingAddress.address || "",
            city: billingAddress.city || "",
            state: billingAddress.state || "",
            country: billingAddress.country || "",
            pin_code: billingAddress.pincode || billingAddress.pin_code || "",
            phone_number: billingAddress.phone_number || "",
          };

          // Format bill_to from billing address
          const billToAddress = formattedBillingAddress.address
            ? `${formattedBillingAddress.address}, ${formattedBillingAddress.city}, ${formattedBillingAddress.state}, ${formattedBillingAddress.country}${formattedBillingAddress.pin_code ? ` - ${formattedBillingAddress.pin_code}` : ""}`
            : "";

          // Map service quotation data to form fields
          const mappedData = {
            ...formik.values,
            // Basic quotation info
            quotation: quotationData.quotation_service_id || quotationData.id,
            quotation_number: quotationData.quotation_number || "",
            reference_number: quotationData.reference_number || "",

            // srv_date should always default to current date, not from quotation
            // Preserve existing srv_date if user has manually set it, otherwise use current date
            srv_date: formik.values.srv_date || getCurrentDate(),
            valid_until: formatDateToDisplay(quotationData.valid_until_date),
            initiated_by: quotationData.initiated_by || "",

            // Enquiry info
            enquiry: quotationData.enquiry_service_id || quotationData.enquiry || "",
            enquiry_number: quotationData.enquiry_number || "",

            // UID Number - auto-fill from quotation if available
            uid_number: quotationData.uid_number || "",

            // Customer details - auto-fill from quotation
            company: companyForForm,
            company_name: companyForForm?.company_name || customerDetails.company_name || customerDetails.customer_name || "",
            company_id: companyForForm?.company_id || companyIdFromQuotation || "",
            company_email: companyForForm?.company_email || customerDetails.company_email || customerDetails.email || "",
            industry: companyForForm?.industry || customerDetails.industry || "",
            industry_name: companyForForm?.industry_name || customerDetails.industry || "",

            // GST details - auto-fill from quotation
            gstin: companyForForm?.gstin || customerDetails.gstin || "",
            gst_type: companyForForm?.gst_type || customerDetails.gst_type || customerDetails.type || "",

            // Contact person array - auto-select from quotation
            contactPersonArray: quotationContacts.length > 0 ? [quotationContacts[0]] : [],
            contactPerson: quotationContacts.length > 0 ? quotationContacts[0] : {},

            // Billing address - auto-fill from quotation
            billing_address: formattedBillingAddress,

            // Bill to - formatted from billing address
            bill_to: billToAddress,
            bill_to_address: formattedBillingAddress,

            // Shipping addresses - auto-fill from quotation
            shipping_addresses: formattedAddresses,

            // Financial details
            currency_applicable:
              quotationData.currency_applicable ??
              !(
                !quotationData.currency_code ||
                quotationData.currency_code === "INR" ||
                quotationData.currency_code === "IND"
              ),
            currency_code: quotationData.currency_code || "INR",
            currency_symbol: quotationData.currency_symbol || "₹",
            exchange_rate: (quotationData.currency_code === "INR" || quotationData.currency_code === "IND" || !quotationData.currency_code)
              ? "1"
              : (quotationData.currency_rate_in_inr || "1"),

            // EMD details
            emd_applicable: quotationData.emd_applicable || false,
            mode_of_emd: quotationData.mode_of_emd || "",
            emd_amount: quotationData.emd_amount || "",

            // Inspection & Installation
            inspection_applicable:
              quotationData.inspection_applicable ??
              !!(quotationData.inspection || quotationData.installation),
            inspection: quotationData.inspection || "Not Applicable",
            inspection_date: formatDateToDisplay(quotationData.inspection_date),
            installation: quotationData.installation || "Not Applicable",
            installation_date: formatDateToDisplay(quotationData.installation_date),

            // Notes and attachments
            notes: quotationData.notes || "",
            attachments: normalizeAttachmentUrls(quotationData.attachments),

            // Tags from quotation
            tags:
              Array.isArray(quotationData.tags) && quotationData.tags.length > 0
                ? quotationData.tags
                    .map((t: any) => String(t).trim())
                    .filter((t: string) => t.length > 0)
                : [],

            // Terms and conditions
            terms_and_conditions: [],

            // Agent name (if any)
            agent_name: quotationData.agent_name || "",
            members: mapAssignedMembersFromQuotation(quotationData.assigned_members || [], membersOptions),
            technicians: mapTechniciansFromQuotation(quotationData.assigned_technician || [], technicianOptions),

            // Status (default to empty or appropriate status)
            status: "",

            // Composition GST - auto-fill from quotation if available
            composition_gst: quotationData.composition_gst || false,
            select_composition_gst: quotationData.select_composition_gst || "",
          };

          // console.log("Mapped service quotation data - contactPersonArray:", mappedData.contactPersonArray);
          formik.setValues(mappedData as any);
          // console.log("Form values after setting - contactPersonArray:", formik.values.contactPersonArray);

          // Set items if they exist
          if (quotationData.quotation_service_items && Array.isArray(quotationData.quotation_service_items)) {
            const mappedItems = quotationData.quotation_service_items.map((item: any) => mapQuotationItemToFormItem(item));
            // console.log("mappedServiceItems in line 1375", mappedItems)
            setItems(mappedItems);
          }
        }
      } catch (error) {
        console.error("Failed to load service quotation data:", error);
      } finally {
        setLoading(false);
      }
    }, [quotationData, companies]);

    // ---- Fetch and Load Logic (Main useEffect) ----
    useEffect(() => {
      // console.log("useEffect called");
      const loadData = async () => {
        // Only load data if initialData has actual data (not empty object)
        // Check for quotation_service_id, quotation_product_id, or id
        if (!initialData || (!initialData.id && !initialData.quotation_service_id && !initialData.quotation_product_id)) {
          return;
        }

        setLoading(true);

        try {
          if (initialData) {
            // console.log("Setting form values from quotation data");

            // Extract customer details from quotation data
            const customerDetails = initialData.customer_details || {};
            const companyIdFromQuotation = customerDetails.company_id || customerDetails.customer_id;

            // Find the full company object from the companies array
            const companyObj = companyIdFromQuotation
              ? companies.find((c) => c.id === companyIdFromQuotation || c.company_id === companyIdFromQuotation) || null
              : null;

            // Extract shipping addresses - check both company object and customer_details
            let formattedAddresses: any[] = [];

            // First, try to get from company object
            if (companyObj?.shipping_addresses && Array.isArray(companyObj.shipping_addresses)) {
              formattedAddresses = companyObj.shipping_addresses.map(
                (addr: any) => ({
                  id: addr.id || addr.shipping_address_id,
                  address: addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
                  state: addr.state,
                  city: addr.city,
                  pin_code: addr.pincode || addr.pin_code,
                  phone_number: addr.phone_number,
                })
              );
            }

            // If no addresses from company, try from customer_details.shipping_address
            if (formattedAddresses.length === 0 && customerDetails.shipping_address && Array.isArray(customerDetails.shipping_address)) {
              formattedAddresses = customerDetails.shipping_address.map(
                (addr: any) => ({
                  id: addr.shipping_address_id || addr.id,
                  address: addr.address || `${addr.city}, ${addr.state}, ${addr.pincode || addr.pin_code}`,
                  state: addr.state,
                  city: addr.city,
                  pin_code: addr.pincode || addr.pin_code,
                  phone_number: addr.phone_number,
                })
              );
            }

            setShippingAddresses(formattedAddresses);

            // Transform contacts from quotation's customer_details to form format (for auto-selection)
            const quotationContacts = (customerDetails.contact_details || customerDetails.contacts || []).map((contact: any) => ({
              id: contact.contact_id || contact.id || "",
              contact_person_name: contact.name || contact.contact_person_name || "",
              contact_person_email: contact.email || contact.contact_person_email || "",
              contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
              contact_person_designation: contact.designation || contact.contact_person_designation || "",
              contact_person_department: contact.contact_person_department || "",
            }));

            // Get ALL contacts from the company object (not just from quotation)
            // This ensures all available contacts are shown in the dropdown
            const masterContacts = companyObj
              ? (companyObj.contact_details || companyObj.contacts || []).map((contact: any) => ({
                id: contact.contact_id || contact.id || "",
                contact_id: contact.contact_id || contact.id || "",
                contact_person_name: contact.name || contact.contact_person_name || "",
                contact_person_email: contact.email || contact.contact_person_email || "",
                contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
                contact_person_designation: contact.designation || contact.contact_person_designation || "",
                contact_person_department: contact.contact_person_department || "",
              }))
              : [];

            // Merge quotation contacts with master contacts
            const mergedContacts = [...masterContacts];
            quotationContacts.forEach((qc: any) => {
              const alreadyPresent = mergedContacts.some(mc =>
                (mc.id && qc.id && mc.id === qc.id) ||
                (mc.contact_id && qc.contact_id && mc.contact_id === qc.contact_id) ||
                (mc.contact_person_email && qc.contact_person_email && mc.contact_person_email.toLowerCase() === qc.contact_person_email.toLowerCase())
              );
              if (!alreadyPresent) {
                mergedContacts.push(qc);
              }
            });

            // Create company object with proper structure for autocomplete
            // Use merged contacts so user can select from all available contacts
            const companyForForm: any = companyObj ? {
              id: companyObj.id || companyObj.company_id,
              company_id: companyObj.company_id || companyObj.id,
              company_name: companyObj.company_name || customerDetails.company_name || customerDetails.customer_name || "",
              company_email: companyObj.company_email || customerDetails.company_email || customerDetails.email || "",
                vendor_code: companyObj.vendor_code || "",
            branch_name: companyObj.branch_name || "",
              industry: companyObj.industry || customerDetails.industry || "",
              industry_name: companyObj.industry || customerDetails.industry || "",
              contact_details: mergedContacts, // Use merged contacts
              gstin: companyObj.gstin || customerDetails.gstin || "",
              gst_type: companyObj.gst_type || customerDetails.gst_type || customerDetails.type || "",
              phone_number: companyObj.phone_number || customerDetails.phone_number || "",
              sr_no: companyObj.sr_no || customerDetails.sr_no || 1,
              billing_address: companyObj.billing_address || customerDetails.billing_address,
              shipping_addresses: formattedAddresses.length > 0 ? formattedAddresses : (companyObj.shipping_addresses || []),
            } : (companyIdFromQuotation ? {
              // If company not found in companies array, create from customerDetails
              id: companyIdFromQuotation,
              company_id: companyIdFromQuotation,
              company_name: customerDetails.company_name || customerDetails.customer_name || "",
              company_email: customerDetails.company_email || customerDetails.email || "",
                vendor_code: customerDetails.vendor_code || "",
            branch_name: customerDetails.branch_name || "",
              industry: customerDetails.industry || "",
              industry_name: customerDetails.industry || "",
              contact_details: mergedContacts, // Use merged contacts (will just be quotation ones here)
              gstin: customerDetails.gstin || "",
              gst_type: customerDetails.gst_type || customerDetails.type || "",
              phone_number: customerDetails.phone_number || "",
              sr_no: customerDetails.sr_no || 1,
              billing_address: customerDetails.billing_address,
              shipping_addresses: formattedAddresses,
            } : null);

            // Format billing address properly
            const billingAddress = customerDetails.billing_address || companyObj?.billing_address || {};
            const formattedBillingAddress = {
              address: billingAddress.address || "",
              city: billingAddress.city || "",
              state: billingAddress.state || "",
              country: billingAddress.country || "",
              pin_code: billingAddress.pincode || billingAddress.pin_code || "",
              phone_number: billingAddress.phone_number || "",
            };

            // Format bill_to from billing address
            const billToAddress = formattedBillingAddress.address
              ? `${formattedBillingAddress.address}, ${formattedBillingAddress.city}, ${formattedBillingAddress.state}, ${formattedBillingAddress.country}${formattedBillingAddress.pin_code ? ` - ${formattedBillingAddress.pin_code}` : ""}`
              : "";

            // Map quotation data to form fields
            // console.log("companyForForm in line 1547", companyForForm)
            const mappedData = {
              ...formik.values,
              // Basic quotation info
              quotation: initialData.quotation_product_id || initialData.quotation_service_id || initialData.id,
              quotation_number: initialData.quotation_number || "",
            reference_number: initialData.reference_number || "",
              quotation_date: formatDateToDisplay(initialData.quotation_date),
              // valid_until_date: getCurrentDate(),
              initiated_by: initialData.initiated_by || "",

              // Enquiry info
              enquiry: initialData.enquiry_product_id || initialData.enquiry_service_id || initialData.enquiry || "",
              enquiry_number: initialData.enquiry_number || "",

              // Customer details - auto-fill from quotation
              company: companyForForm,
              company_name: companyForForm?.company_name || customerDetails.company_name || customerDetails.customer_name || "",
              company_id: companyForForm?.company_id || companyIdFromQuotation || "",
              company_email: companyForForm?.company_email || customerDetails.company_email || customerDetails.email || "",
              industry: companyForForm?.industry || customerDetails.industry || "",
              industry_name: companyForForm?.industry_name || customerDetails.industry || "",

              // GST details - auto-fill from quotation
              gstin: companyForForm?.gstin || customerDetails.gstin || "",
              gst_type: companyForForm?.gst_type || customerDetails.gst_type || customerDetails.type || "",

              // Contact person array - auto-select first contact from quotation (if available)
              // But all company contacts will be available in the dropdown
              contactPersonArray: quotationContacts.length > 0 ? [quotationContacts[0]] : [],
              contactPerson: quotationContacts.length > 0 ? quotationContacts[0] : {},

              // Billing address - auto-fill from quotation
              billing_address: formattedBillingAddress,

              // Bill to - formatted from billing address
              bill_to: billToAddress,
              bill_to_address: formattedBillingAddress,

              // Shipping addresses - auto-fill from quotation
              shipping_addresses: formattedAddresses,

              // Financial details
              currency_applicable:
                initialData.currency_applicable ??
                !(
                  !initialData.currency_code ||
                  initialData.currency_code === "INR" ||
                  initialData.currency_code === "IND"
                ),
              currency_code: initialData.currency_code || "INR",
              currency_symbol: initialData.currency_symbol || "₹",
              exchange_rate: (initialData.currency_code === "INR" || initialData.currency_code === "IND" || !initialData.currency_code)
                ? "1"
                : (initialData.currency_rate_in_inr || "1"),

              // EMD details
              emd_applicable: initialData.emd_applicable || false,
              mode_of_emd: initialData.mode_of_emd || "",
              emd_amount: initialData.emd_amount || "",

              // Inspection & Installation
              inspection_applicable:
                initialData.inspection_applicable ??
                !!(initialData.inspection || initialData.installation),
              inspection: initialData.inspection || "Not Applicable",
              inspection_date: formatDateToDisplay(initialData.inspection_date),
              installation: initialData.installation || "Not Applicable",
              installation_date: formatDateToDisplay(initialData.installation_date),

              // PO details (if any)
              customer_po_number: initialData.customer_po_number || "",
              customer_po_date: formatDateToDisplay(initialData.customer_po_date),

              // Notes and attachments
              notes: initialData.notes || "",
              attachments: normalizeAttachmentUrls(initialData.attachments),

              // Terms and conditions
              terms_and_conditions: transformTermsAndConditions(initialData.terms_and_conditions || []),

              // Agent name (if any)
              agent_name: initialData.agent_name || "",
            members: mapAssignedMembersFromQuotation(initialData.assigned_members || [], membersOptions),
                        technicians: mapTechniciansFromQuotation(initialData.assigned_technician || [], technicianOptions),

              // Status (default to empty or appropriate status)
              status: "",

              // Sales Order Date - default to current date if not provided
              srv_date: (() => {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, "0");
                const day = String(today.getDate()).padStart(2, "0");
                return `${year}-${month}-${day}`;
              })(),

              // Composition GST - auto-fill from quotation if available
              composition_gst: initialData.composition_gst || false,
              select_composition_gst: initialData.select_composition_gst || "",
            };

            // console.log("Mapped data - contactPersonArray:", mappedData.contactPersonArray);
            // console.log("Mapped data - company.contact_details:", mappedData.company?.contact_details);
            formik.setValues(mappedData as any);
            // console.log("Form values after setting - contactPersonArray:", formik.values.contactPersonArray);
            // console.log("Form values after setting - company.contact_details:", formik.values.company?.contact_details);

            // Set items if they exist (handle both product and service quotations)
            const quotationItems = initialData.quotation_service_items;
            if (quotationItems && Array.isArray(quotationItems)) {
              const mappedItems = quotationItems.map((item: any) => mapQuotationItemToFormItem(item));
              // console.log("mappedItems in line 809", mappedItems)
              // console.log("Setting items from quotation:", mappedItems.map(item :any => ({
              //   product_name: item.product_name,
              //   gst_percent: item.gst_percent,
              //   gst_value: item.gst_value,
              //   gst_amount: item.gst_amount
              // })));
              setItems(mappedItems);
            }

            // Shipping addresses are already set above if company was found
          }
        } catch (error) {
          // console.error("Failed to load data:", error);
          toast.error("Failed to load data for the form.");
        } finally {
          setLoading(false);
        }
      };

      loadData();
    }, [routeId, pro_type, isEdit, initialData, dispatch, companies]);

    // const handleSubmit = async (e: any, action: "draft" | "print" | "save") => {
    //   e.preventDefault();

    //   if (formData.members.length === 0) {
    //     toast("Please select at least one member");
    //     return;
    //   }
    //   console.log("formData and items on submit: ", formData, items);
    //   console.log("type", type);
    //   const payload = buildSalesOrderPayload(
    //     formData,
    //     items,
    //     type,
    //     shippingAddresses,
    //     organizationsState
    //   );

    //   console.log("✅ Final Sales Order Payload:", payload);

    //   try {
    //     setLoading(true);

    //     // await onSave(payload, action);
    //     // Navigation is handled by parent form component
    //   } catch (err: any) {
    //     toast.error(err?.message || "Operation failed.");
    //   } finally {
    //     setLoading(false);
    //   }
    // };
    // console.log("formik values in line 1105", formik.values)
    // Helper function to check if there are actual validation errors (not just empty nested objects)
    const hasValidationErrors = (errors: any): boolean => {
      if (!errors || typeof errors !== 'object') {
        return false;
      }

      for (const key in errors) {
        const error = errors[key];
        if (error === undefined || error === null) {
          continue;
        }

        if (typeof error === 'string' && error.trim() !== '') {
          // Found a non-empty error string
          return true;
        }

        if (Array.isArray(error)) {
          // Check if array has any non-empty error strings
          if (error.some((e: any) => typeof e === 'string' && e.trim() !== '')) {
            return true;
          }
        }

        if (typeof error === 'object') {
          // Recursively check nested objects
          if (hasValidationErrors(error)) {
            return true;
          }
        }
      }

      return false;
    };

    // Helper function to mark all fields (including nested) as touched
    const markAllFieldsAsTouched = (errors: any, touched: any = {}, values: any = {}): any => {
      const newTouched: any = { ...touched };

      // Mark all top-level fields with errors as touched
      Object.keys(errors).forEach((key) => {
        if (typeof errors[key] === 'object' && errors[key] !== null && !Array.isArray(errors[key])) {
          // Nested object - recursively mark nested fields
          newTouched[key] = markAllFieldsAsTouched(
            errors[key],
            touched[key] || {},
            values[key] || {}
          );
        } else if (Array.isArray(errors[key])) {
          // Array of errors - mark the array field as touched
          newTouched[key] = true;
        } else {
          // Simple field with error - mark as touched
          newTouched[key] = true;
        }
      });

      return newTouched;
    };

    const handleSubmitAction = async (
      values: SalesOrderDataRetrive,
      action: "draft" | "save" | "print"
    ) => {
      // console.log("FORM1 DATA  =>", values);
      // console.log("FORM1 ACTION  => ", action);

      // Validate items only for final save; drafts require only customer.
      if (action !== "draft" && (!items || items.length === 0)) {
        return;
      }

      const payload = buildSalesOrderPayload(
        values,
        items,

        action,
        shippingAddresses,
        organizationsState,
        false // isEdit = false for create form
      );
      // console.log("payload in line 1146", payload)
      try {
        // Set appropriate loading state based on action
        if (action === "draft") {
          setSavingDraft(true);
        } else {
          setSaving(true);
        }
        await onSave(payload, action);
      } catch (err: any) {
        // Extract error message from various possible error structures
        const errorMessage =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.response?.data ||
          err?.message ||
          (typeof err === 'string' ? err : "Operation failed.");

        toast.error(errorMessage);
        throw err; // Re-throw error so caller knows it failed
      } finally {
        // Reset appropriate loading state based on action
        if (action === "draft") {
          setSavingDraft(false);
        } else {
          setSaving(false);
        }
      }
    };
    // console.log("quotationData in line 1488", quotationData)
    // console.log("shipping addresses in line 1184", shippingAddresses)
    return (
      <>
        <style>
          {`
                  .accordion-terms-conditions .accordion-button,
                  .accordion-notes .accordion-button,
                  .accordion-attach-files .accordion-button {
                    background-color: ${MecordColors?.LightThemeBGColor} !important;
                    color: ${MecordColors?.ActiveText} !important;
                  }
                  .accordion-terms-conditions .accordion-button:not(.collapsed),
                  .accordion-notes .accordion-button:not(.collapsed),
                  .accordion-attach-files .accordion-button:not(.collapsed) {
                    background-color: ${MecordColors?.LightThemeBGColor} !important;
                    color: ${MecordColors?.ActiveText} !important;
                  }
                `}
        </style>

        <PageContainer>
          {/* ---- Header ---- */}
          <FormBreadcrumb
            formName={
              "Service Order"
            }
            isEdit={isEdit}
            navigatePath={

              "/sales_order/service/sales_order_log"
            }
          />


          <Form onSubmit={formik.handleSubmit}>
            <Row className="mb-4 g-4">
              {/* Sales Order Details*/}
              <Col xs={12} md={6}>
                <div className="rounded mb-3">
                  <div className="d-flex justify-content-start mb-3">
                    <h5 className="fw-semibold mb-2">Sales Order Details</h5>
                  </div>
                  <Row
                    className="g-3 pb-3 px-1 rounded"
                    style={{ backgroundColor: MecordColors?.LightGrayColor }}
                  >
                    {/* srv date */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          SRF Date{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Control
                          type="date"
                          name="srv_date"
                          value={formatDateToDisplay(formik.values.srv_date)}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          readOnly={isEdit}
                          isInvalid={
                            formik.touched.srv_date &&
                            !!formik.errors.srv_date
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.srv_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Schedule Service Date */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Schedule Service Date <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Control
                          type="date"
                          name="schedule_service_date"
                          autoComplete="off"
                          value={formatDateToDisplay(formik.values.schedule_service_date)}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          readOnly={isEdit}
                          isInvalid={
                            formik.touched.schedule_service_date && !!formik.errors.schedule_service_date
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.schedule_service_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* QUOTATION AUTOCOMPLETE */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Quotation Number
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>

                        <Autocomplete
                          options={
                            Array.isArray(quotationReferences)
                              ? quotationReferences
                              : []
                          }
                          value={
                            quotationReferences.find(
                              (q: any) => q.quotation_service_id === formik.values.quotation
                            ) || null
                          }
                          getOptionLabel={(option) =>
                            option.service_quotation_name ||
                            option.quotation_number ||
                            ""
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.quotation_service_id === value.quotation_service_id || option.id === value.id
                          }
                          onChange={(_, newValue) => {
                            if (newValue) {
                              formik.setFieldValue("quotation", newValue.quotation_service_id || newValue.id);
                              formik.setFieldValue(
                                "quotation_number",
                                newValue.service_quotation_name ||
                                newValue.quotation_number
                              );
                              handleQuotationSelect(newValue.quotation_service_id || newValue.id);
                            } else {
                              // Clear all quotation-related fields
                              formik.setFieldValue("quotation", "");
                              formik.setFieldValue("quotation_number", "");
                              // srv_date should always default to current date, not be cleared
                              formik.setFieldValue("srv_date", getCurrentDate());
                              formik.setFieldValue("valid_until", "");
                              formik.setFieldValue("schedule_service_date", "");
                              formik.setFieldValue("enquiry", "");
                              formik.setFieldValue("enquiry_number", "");
                              formik.setFieldValue("uid_number", "");
                              formik.setFieldValue("reference_number", "");
                              formik.setFieldValue("initiated_by", "");
                              formik.setFieldValue("company_name", "");
                              formik.setFieldValue("company_id", "");
                              formik.setFieldValue("company_email", "");
                              formik.setFieldValue("industry", "");
                              formik.setFieldValue("industry_name", "");
                              formik.setFieldValue("gstin", "");
                              formik.setFieldValue("gst_type", "");
                              formik.setFieldValue("contactPersonArray", []);
                              formik.setFieldValue("contactPerson", {});
                              formik.setFieldValue("company", null);
                              formik.setFieldValue("billing_address", {
                                address: "",
                                city: "",
                                state: "",
                                country: "",
                                pin_code: "",
                                phone_number: "",
                              });
                              formik.setFieldValue("shipping_addresses", []);
                              formik.setFieldValue("currency_code", "INR");
                              formik.setFieldValue("currency_symbol", "₹");
                              formik.setFieldValue("exchange_rate", "1");
                              formik.setFieldValue("mode_of_emd", "");
                              formik.setFieldValue("emd_amount", "");
                              formik.setFieldValue("inspection", "");
                              formik.setFieldValue("inspection_date", "");
                              formik.setFieldValue("installation", "");
                              formik.setFieldValue("installation_date", "");
                              formik.setFieldValue("customer_po_number", "");
                              formik.setFieldValue("customer_po_date", "");
                              formik.setFieldValue("customer_po_document_url", null);
                              formik.setFieldValue("notes", "");
                              formik.setFieldValue("attachments", []);
                              formik.setFieldValue("terms_and_conditions", []);
                              formik.setFieldValue("agent_name", "");
                              formik.setFieldValue("composition_gst", false);
                              formik.setFieldValue("select_composition_gst", "");
                              setItems([]);
                              setShippingAddresses([]);
                              setQuotationData(null);
                            }
                          }}
                          onBlur={() =>
                            formik.setFieldTouched("quotation", true)
                          }
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Select Quotation"
                              size="small"
                              error={
                                formik.touched.quotation &&
                                !!formik.errors.quotation
                              }
                              helperText={
                                formik.touched.quotation &&
                                formik.errors.quotation
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>

                    {/* UID Number field - auto-fills from quotation if available */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>UID Number</Form.Label>
                        <InputGroup style={{ position: 'relative' }}>
                          <Form.Control
                            type="text"
                            name="uid_number"
                            value={formik.values.uid_number || ''}
                            readOnly
                            placeholder="Click icon to generate"
                            style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed', paddingRight: '40px' }}
                            isInvalid={
                              formik.touched.uid_number &&
                              !!formik.errors.uid_number
                            }
                          />
                          <div
                            style={{
                              position: 'absolute',
                              right: '12px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              backgroundColor: 'transparent',
                              border: 'none',
                              padding: '0',
                              zIndex: 10,
                              cursor: isGeneratingUid ? 'not-allowed' : 'pointer',
                              pointerEvents: isGeneratingUid ? 'none' : 'auto',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            onClick={isGeneratingUid ? undefined : (hasUidNumber ? handleClearUid : handleGenerateUid)}
                          >
                            {isGeneratingUid ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{ width: '18px', height: '18px', borderWidth: '2px' }}
                              />
                            ) : hasUidNumber ? (
                              <ClearIcon
                                style={{
                                  fontSize: '18px',
                                  color: MecordColors.SecondaryButtonTextColor,
                                  cursor: 'pointer',
                                }}
                              />
                            ) : (
                              <AutoModeIcon
                                style={{
                                  fontSize: '18px',
                                  color: MecordColors.PrimaryButtonBGColor,
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                          </div>
                        </InputGroup>
                        {formik.touched.uid_number && formik.errors.uid_number && (
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.uid_number as string}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Reference Number */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Reference Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="reference_number"
                          value={formik.values.reference_number || ""}
                          readOnly
                        />
                      </Form.Group>
                    </Col>

                    {/* Enquiry Reference Number */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Enquiry Reference Number</Form.Label>

                        <Form.Control
                          type="text"
                          name="enquiry_number"
                          value={formik.values.enquiry_number}
                          readOnly
                          isInvalid={
                            formik.touched.enquiry_number &&
                            !!formik.errors.enquiry_number
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.enquiry_number}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Initiated By */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Initiated By <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="initiated_by"
                          placeholder="Enter Name"
                          value={formik.values.initiated_by}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.initiated_by &&
                            !!formik.errors.initiated_by
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.initiated_by}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>


                  </Row>
                </div>
              </Col>

              {/* Company/Customer Details - RIGHT COLUMN */}
              <Col xs={12} md={6}>
                <div className="rounded mb-3">
                  <div className="d-flex justify-content-start align-items-center mb-3 gap-2">
                    <h5 className="fw-semibold mb-0 me-1">Customer Details</h5>
                    <Button
                      size="sm"
                      variant="light"
                      className="fw-semibold mb-1 rounded"
                      onClick={() => setShowCompanyModal(true)}
                      disabled={!!(formik.values.quotation || formik.values.quotation_number)}
                      style={{
                        backgroundColor: MecordColors?.LightGrayColor,
                      }}
                    >
                      + Add New Company
                    </Button>
                  </div>
                  <Row
                    className="g-3 pb-3 px-1 rounded"
                    style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                  >
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>
                          Select Customer <span className="text-danger">*</span>
                        </Form.Label>

                        <Autocomplete
                          disabled={!!(formik.values.quotation || formik.values.quotation_number)}
                          options={companies}
                          getOptionLabel={(option) => option?.company_name || ""}
                          isOptionEqualToValue={(option, value) => {
                            if (!option || !value) return false;

                            // Get IDs from both option and value, ensuring they're not empty strings
                            const optionCompanyId = option.company_id;
                            const optionId = option.id;
                            const valueCompanyId = value.company_id;
                            const valueId = value.id;

                            // Only compare if IDs are truthy (not empty strings, null, or undefined)
                            // Priority: exact matches first (company_id to company_id, id to id)
                            if (optionCompanyId && valueCompanyId && optionCompanyId === valueCompanyId) {
                              return true;
                            }
                            if (optionId && valueId && optionId === valueId) {
                              return true;
                            }

                            // Cross-match only if exact matches didn't work
                            if (optionCompanyId && valueId && optionCompanyId === valueId) {
                              return true;
                            }
                            if (optionId && valueCompanyId && optionId === valueCompanyId) {
                              return true;
                            }

                            return false;
                          }}
                          value={
                            // Only show company if it has a valid ID (not empty object)
                            formik.values.company &&
                              (formik.values.company.company_id || formik.values.company.id) &&
                              (formik.values.company.company_id !== "" && formik.values.company.id !== "")
                              ? companies.find((c) => {
                                const formCompanyId = formik.values.company?.company_id;
                                const formId = formik.values.company?.id;
                                const cCompanyId = c.company_id;
                                const cId = c.id;

                                // Exact matches first
                                if (formCompanyId && cCompanyId && formCompanyId === cCompanyId) return true;
                                if (formId && cId && formId === cId) return true;

                                // Cross-matches
                                if (formCompanyId && cId && formCompanyId === cId) return true;
                                if (formId && cCompanyId && formId === cCompanyId) return true;

                                return false;
                              }) || null
                              : null
                          }
                          onChange={async (_, newValue) => {
                            if (newValue) {
                              // Check if we're changing to a different company
                              const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
                              const newCompanyId = newValue.company_id || newValue.id || "";
                              const isChangingCompany = currentCompanyId && currentCompanyId !== newCompanyId;

                              // If changing company and there are items, show confirmation
                              if (isChangingCompany && items && items.length > 0) {
                                const confirmed = await showConfirm(
                                  "Change Customer?",
                                  "Changing the customer will clear all products and services. Do you want to continue?",
                                  "Yes, change customer",
                                  "Cancel"
                                );

                                if (!confirmed.isConfirmed) {
                                  return; // User cancelled, don't change company
                                }

                                // Clear items
                                setItems([]);
                              }

                              // Map API response structure to form structure
                              const companyId = newCompanyId;

                              // Transform contacts from API format to form format
                              const transformedContacts = (newValue.contacts || []).map((contact: any) => ({
                                id: contact.contact_id || contact.id || "",
                                contact_person_name: contact.name || contact.contact_person_name || "",
                                contact_person_email: contact.email || contact.contact_person_email || "",
                                contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
                                contact_person_designation: contact.designation || contact.contact_person_designation || "",
                                contact_person_department: contact.contact_person_department || "",
                              }));

                              // Create company object with proper structure
                              const companyObj = {
                                id: companyId,
                                company_id: companyId,
                                company_name: newValue.company_name || "",
                                vendor_code: newValue.vendor_code || "",
                                branch_name: newValue.branch_name || "",
                                industry: newValue.industry || "", // For form display
                                industry_name: newValue.industry || "", // For formik values
                                contact_details: transformedContacts,
                                gstin: newValue.gstin || "",
                                gst_type: newValue.gst_type || "",
                                phone_number: newValue.phone_number || "",
                                sr_no: newValue.sr_no || 1,
                              };

                              // Set company object
                              formik.setFieldValue("company", companyObj);

                              // Set top-level company fields
                              formik.setFieldValue(
                                "company_name",
                                newValue.company_name || ""
                              );
                              setTimeout(() => formik.setFieldError("company_name", undefined), 0);
                              formik.setFieldValue(
                                "company_email",
                                newValue.company_email || ""
                              );
                              formik.setFieldValue(
                                "industry",
                                newValue.industry || ""
                              );
                              formik.setFieldValue(
                                "company_id",
                                companyId
                              );

                              // Set billing address (map API structure to form structure)
                              const billingAddr = newValue.billing_address || {};
                              formik.setFieldValue(
                                "billing_address",
                                {
                                  address: billingAddr.address || "",
                                  city: billingAddr.city || "",
                                  state: billingAddr.state || "",
                                  country: billingAddr.country || "",
                                  pin_code: billingAddr.pincode || billingAddr.pin_code || "",
                                  phone_number: billingAddr.phone_number || "",
                                }
                              );

                              // Set shipping addresses in state & Formik
                              const formattedAddresses = (
                                newValue.shipping_addresses || []
                              ).map((addr: any) => ({
                                id: addr.shipping_address_id || addr.id || "",
                                address: addr.address || "",
                                state: addr.state || "",
                                city: addr.city || "",
                                pin_code: addr.pincode || addr.pin_code || "",
                                phone_number: addr.phone_number || "",
                                country: addr.country || "",
                              }));

                              setShippingAddresses(formattedAddresses); // for dropdown/state
                              formik.setFieldValue(
                                "shipping_addresses",
                                formattedAddresses
                              ); // for formik

                              // Don't auto-select contact persons - let user choose
                              formik.setFieldValue("contactPersonArray", []);
                              formik.setFieldValue("contactPerson", {});
                            } else {
                              // Customer is being removed - check if there are items
                              const handleCompanyRemoval = async () => {
                                const hasItems = items && items.length > 0;

                                if (hasItems) {
                                  const confirmed = await showConfirm(
                                    "Remove Customer?",
                                    "Removing the customer will clear all products and services. Do you want to continue?",
                                    "Yes, remove customer",
                                    "Cancel"
                                  );

                                  if (!confirmed?.isConfirmed) {
                                    return; // User cancelled, don't remove company
                                  }

                                  // Clear items
                                  setItems([]);
                                }

                                // Clear fields if no company selected
                                formik.setFieldValue("company", null);
                                formik.setFieldValue("company_name", "");
                                formik.setFieldValue("company_email", "");
                                formik.setFieldValue("industry_name", "");
                                formik.setFieldValue("company_id", "");
                                formik.setFieldValue("billing_address", {});
                                formik.setFieldValue("contactPerson", {});
                                formik.setFieldValue("contactPersonArray", []);
                                setShippingAddresses([]);
                                formik.setFieldValue("shipping_addresses", []);
                              };

                              handleCompanyRemoval();
                            }
                          }}
                          onBlur={() => {
                            formik.setFieldTouched("company_name", true);
                            formik.validateField("company_name");
                          }}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderOption={(props, option, { selected }) => {
                            const { key, ...otherProps } = props;
                            return (
                              <li key={key} {...otherProps} style={{ padding: 0 }}>
                                <Box
                                  sx={{
                                    px: 1.5,
                                    py: 0.8,
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: MecordColors.Hover,
                                      color: MecordColors.ActiveText,
                                    },
                                    ...(selected && {
                                      backgroundColor: MecordColors.ActiveBackground,
                                      color: MecordColors.ActiveText,
                                    }),
                                  }}
                                >
                                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                                    <span>{option?.company_name || ""}</span>
                                    {option?.branch_name && (
                                      <span
                                        style={{
                                          fontSize: "0.75rem",
                                          color: "#6c757d",
                                          marginTop: 2,
                                        }}
                                      >
                                        {option.branch_name}
                                      </span>
                                    )}
                                  </Box>
                                </Box>
                              </li>
                            );
                          }}
                          renderInput={(params: any) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Select Customer"
                              variant="outlined"
                              size="small"
                              error={
                                formik.touched.company_name &&
                                !!formik.errors?.company_name
                              }
                              helperText={
                                formik.touched.company_name &&
                                  formik.errors?.company_name
                                  ? (formik.errors.company_name as string)
                                  : ""
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Industry</Form.Label>
                        <Form.Control
                          type="text"

                          placeholder="Autofill"
                          value={formik?.values?.company?.industry || ""}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>GST Type</Form.Label>
                        <Form.Control
                          type="text"
                          readOnly
                          placeholder="Autofill"
                          value={formik?.values?.company?.gst_type || ""}

                        />
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>
                          Contact Person <span className="text-danger">*</span>
                        </Form.Label>
                        {/* Autocomplete for adding contact persons */}
                        <Autocomplete
                          multiple
                          disableCloseOnSelect
                          options={formik.values.company?.contact_details || []}
                          getOptionLabel={(option: any) =>
                            option.contact_person_name ||
                            option.name ||
                            ""
                          }
                          isOptionEqualToValue={(option: any, value: any) => {
                            // Future-safe: use ID when backend starts sending it
                            if (option.id && value.id)
                              return option.id === value.id;

                            // Current workaround: match by email
                            return (
                              option.contact_person_email ===
                              value.contact_person_email
                            );
                          }}
                          value={formik.values.contactPersonArray || []}
                          onChange={(_, newValue: any[]) => {
                            // Remove duplicates using email (currently)
                            const uniqueContacts = newValue.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (item) =>
                                    (item.id && v.id && item.id === v.id) || // future ID support
                                    item.contact_person_email ===
                                    v.contact_person_email // current fallback
                                ) === i
                            );

                            formik.setFieldValue(
                              "contactPersonArray",
                              uniqueContacts
                            );
                            setTimeout(() => formik.setFieldError("contactPersonArray", undefined), 0);
                          }}
                          onBlur={() =>
                            formik.setFieldTouched("contactPersonArray", true)
                          }
                          renderTags={() => null}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderOption={(props: any, option: any, { selected }: any) => {
                            const { key, ...otherProps } = props;
                            const label =
                              option?.contact_person_name || option?.name || "";

                            return (
                              <li key={key} {...otherProps} style={{ padding: 0 }}>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    padding: "8px 12px",
                                    backgroundColor: selected
                                      ? MecordColors.ActiveBackground
                                      : "transparent",
                                    color: selected ? MecordColors.ActiveText : "inherit",
                                  }}
                                >
                                  <span>{label}</span>
                                  {selected && (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        color: "#d32f2f",
                                        fontWeight: "bold",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        const current =
                                          formik.values.contactPersonArray || [];

                                        const isSame = (a: any, b: any) => {
                                          if (!a || !b) return false;
                                          if (a.id && b.id && a.id === b.id) return true;
                                          const aEmail =
                                            a.contact_person_email || a.email || "";
                                          const bEmail =
                                            b.contact_person_email || b.email || "";
                                          return !!(aEmail && bEmail && aEmail === bEmail);
                                        };

                                        const updated = current.filter(
                                          (c: any) => !isSame(option, c)
                                        );

                                        formik.setFieldValue(
                                          "contactPersonArray",
                                          updated
                                        );
                                      }}
                                    >
                                      ✕
                                    </span>
                                  )}
                                </div>
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Search Contact Person"
                              size="small"
                              error={
                                formik.touched.contactPersonArray &&
                                !!formik.errors.contactPersonArray
                              }
                              helperText={
                                formik.touched.contactPersonArray &&
                                  typeof formik.errors.contactPersonArray ===
                                  "string"
                                  ? formik.errors.contactPersonArray
                                  : ""
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />

                        {/* Display selected contacts as chips below the input */}
                        <Row>
                          <div className="mt-2 d-flex flex-wrap gap-2">
                            {(formik.values.contactPersonArray || []).map(
                              (contact, index) => (
                                <div
                                  key={contact.id || index}
                                  className="d-flex align-items-center px-2 py-1 rounded"
                                  style={{
                                    background: MecordColors?.LightThemeBGColor,
                                    border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                    fontSize: "14px",
                                  }}
                                >
                                  {contact.contact_person_name}
                                  <span
                                    style={{
                                      marginLeft: "8px",
                                      cursor: "pointer",
                                      color: "red",
                                    }}
                                    onClick={() => {
                                      const updated = (
                                        formik.values.contactPersonArray || []
                                      ).filter((_, i) => i !== index);
                                      formik.setFieldValue(
                                        "contactPersonArray",
                                        updated
                                      );
                                    }}
                                  >
                                    ✕
                                  </span>
                                </div>
                              )
                            )}
                          </div>
                        </Row>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Customer PO Number
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>

                        <Form.Control
                          name="customer_po_number"
                          type="text"
                          placeholder="Enter PO Number"
                          value={formik.values.customer_po_number}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.customer_po_number &&
                            !!formik.errors.customer_po_number
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customer_po_number}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          PO Date
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>

                        <Form.Control
                          name="customer_po_date"
                          type="date"
                          value={formik.values.customer_po_date}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.customer_po_date &&
                            !!formik.errors.customer_po_date
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customer_po_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>

                        {/* Show selected file + remove button */}
                        <FileUpload
                          label="Upload PO Document"
                          multiple
                          maxFiles={1}
                          value={formik.values.customer_po_document_url}
                          onChange={(files) =>
                            formik.setFieldValue(
                              "customer_po_document_url",
                              files
                            )
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customer_po_document_url}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <hr />

            {/* Agent & Members Section */}
            <Row className="mb-4">
              <Col lg={6} md={12}>
                <h5 className="fw-semibold mb-3">Agent Details</h5>
                <div className="p-3 mb-3">
                  <Form.Group>
                    <Form.Label>Agent Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="agent_name"
                      placeholder="Enter Agent Name"
                      value={formik.values.agent_name || ""}
                      onChange={(e) =>
                        formik.setFieldValue("agent_name", e.target.value)
                      }
                      onBlur={() => formik.setFieldTouched("agent_name", true)}
                      isInvalid={
                        formik.touched.agent_name &&
                        !!formik.errors.agent_name
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.agent_name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                {/* Add Tags Section */}

                <div className="p-3 mb-3">
                  <AddTags
                    value={formik.values.tags || []}
                    onChange={(tags) => formik.setFieldValue("tags", tags)}
                  />
                </div>
              </Col>

              <Col lg={6} md={12}>
                <div className="rounded mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3 gap-1">
                    <h5 className="fw-semibold">Add Members</h5>
                  </div>

                  <Row
                    className="g-3 pb-3 px-1 rounded mb-2"
                    style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                  >
                    <Col xs={12} md={12}>
                      <Form.Group>
                        <Form.Label>
                          Assign Members
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>
                        <Autocomplete
                          options={(Array.isArray(membersOptions) ? membersOptions : []).filter(
                            (user: any) => !selectedMemberIds.includes(user.user_id || user.id)
                          )}
                          getOptionLabel={(option: any) =>
                            `${option.first_name || ""} ${option.last_name || ""}`.trim() || ""
                          }
                          isOptionEqualToValue={(option: any, value: any) =>
                            (option.user_id || option.id) === (value.user_id || value.id)
                          }
                          onChange={(_: any, newValue: any | null) => {
                            if (newValue) {
                              handleMemberAdd(newValue);
                            }
                          }}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} style={{ padding: 0 }}>
                              <Box
                                sx={{
                                  px: 1.5,
                                  py: 0.8,
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  "&:hover": {
                                    backgroundColor: MecordColors.Hover,
                                    color: MecordColors.ActiveText,
                                  },
                                  ...(selected && {
                                    backgroundColor: MecordColors.ActiveBackground,
                                    color: MecordColors.ActiveText,
                                  }),
                                }}
                              >
                                <span>{`${option.first_name || ""} ${option.last_name || ""}`.trim()}</span>
                              </Box>
                            </li>
                          )}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Search User"
                              size="small"
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 rounded">
                    {(formik.values.members || []).length > 0 && (
                      <Col xs={12} md={12}>
                        <div className="d-flex flex-wrap gap-2">
                          {(formik.values.members || []).map((member: any) => (
                            <div
                              key={member.id}
                              className="d-flex align-items-center px-2 py-1 rounded gap-2"
                              style={{
                                background: MecordColors?.LightThemeBGColor,
                                border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                fontSize: "14px",
                              }}
                            >
                              <span
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  fontSize: "0.75rem",
                                  fontWeight: "bold",
                                  backgroundColor: "#fff",
                                  color: MecordColors.ThemeBGColor,
                                }}
                              >
                                {member.initials || getInitials(
                                  member.first_name || "",
                                  member.last_name || ""
                                )}
                              </span>
                              {member.name ||
                                (member.first_name && member.last_name
                                  ? `${member.first_name} ${member.last_name}`.trim()
                                  : member.fullname || member.username || member.email || "")}
                              <span
                                style={{
                                  marginLeft: "4px",
                                  cursor: "pointer",
                                  color: "red",
                                }}
                                onClick={() => handleMemberRemove(member.id || member.user_id)}
                              >
                                ✕
                              </span>
                            </div>
                          ))}
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>
              <hr />


              {/* Technicians Section - wrapper id for useScrollToFormikError */}
              <Col md={6}>
                <div id="technicians" className="rounded mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3 gap-1">
                    <h5 className="fw-semibold">Add Engineers</h5>
                  </div>

                  <Row
                    className="g-3 pb-3 px-1 rounded mb-2"
                    style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                  >
                    <Col xs={12} md={12}>
                      <Form.Group>
                        <Form.Label>
                          Select Engineers <span className="text-danger">*</span>
                        </Form.Label>
                        <Autocomplete
                          options={(technicianOptions || []).filter(
                            (tech: any) => !selectedTechnicianIds.includes(tech.user_id || tech.id)
                          )}
                          getOptionLabel={(option: any) =>
                            `${option.first_name || ""} ${option.last_name || ""}`.trim() || ""
                          }
                          isOptionEqualToValue={(option: any, value: any) =>
                            (option.user_id || option.id) === (value.user_id || value.id)
                          }
                          onChange={(_: any, newValue: any | null) => {
                            if (newValue) {
                              handleTechnicianAdd(newValue);
                            }
                          }}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          // renderOption={(props, option, { selected }) => (
                          //   <li {...props} style={{ padding: 0 }}>
                          //     <Box
                          //       sx={{
                          //         px: 1.5,
                          //         py: 0.8,
                          //         width: "100%",
                          //         display: "flex",
                          //         justifyContent: "space-between",
                          //         alignItems: "center",
                          //         cursor: "pointer",
                          //         "&:hover": {
                          //           backgroundColor: MecordColors.Hover,
                          //           color: MecordColors.ActiveText,
                          //         },
                          //         ...(selected && {
                          //           backgroundColor: MecordColors.ActiveBackground,
                          //           color: MecordColors.ActiveText,
                          //         }),
                          //       }}
                          //     >
                          //       <span>{`${option.first_name || ""} ${option.last_name || ""}`.trim()}</span>
                          //     </Box>
                          //   </li>
                          // )}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              inputProps={{
                                ...params.inputProps,
                                name: "technicians",
                              }}
                              placeholder="Search Engineers"
                              size="small"
                              error={
                                formik.touched.technicians &&
                                !!formik.errors.technicians
                              }
                              helperText={
                                formik.touched.technicians
                                  ? Array.isArray(formik.errors.technicians)
                                    ? "Invalid technician selection"
                                    : (formik.errors.technicians as string)
                                  : ""
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 rounded">
                    {(Array.isArray(formik.values.technicians) ? formik.values.technicians : []).length > 0 && (
                      <Col xs={12} md={12}>
                        <div className="d-flex flex-wrap gap-2">
                          {(Array.isArray(formik.values.technicians) ? formik.values.technicians : []).map((tech: any) => (
                            <div
                              key={tech.id}
                              className="d-flex align-items-center px-2 py-1 rounded gap-2"
                              style={{
                                background: MecordColors?.LightThemeBGColor,
                                border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                fontSize: "14px",
                              }}
                            >
                              <span
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  fontSize: "0.75rem",
                                  fontWeight: "bold",
                                  backgroundColor: "#fff",
                                  color: MecordColors.ThemeBGColor,
                                }}
                              >
                                {tech.initials || getInitials(
                                  tech.first_name || "",
                                  tech.last_name || ""
                                )}
                              </span>
                              {tech.name ||
                                (tech.first_name && tech.last_name
                                  ? `${tech.first_name} ${tech.last_name}`.trim()
                                  : tech.fullname || tech.full_name || tech.username || "")}
                              <span
                                style={{
                                  marginLeft: "4px",
                                  cursor: "pointer",
                                  color: "red",
                                }}
                                onClick={() => handleTechnicianRemove(tech.id || tech.user_id)}
                              >
                                ✕
                              </span>
                            </div>
                          ))}
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>
            </Row>


            {/* PBG Details */}
            <hr />

       


       
            <Row className="mb-3">
              <Col md={12}>
                <Row className="g-3">
                  <h5 className="mb-3 fw-semibold mb-3" >
                    <Form.Check
                      type="checkbox"
                      label="PBG  (Performance Bank Guarantee) Details"
                      name="pbg_details.pbg_required"
                      checked={formik.values.pbg_details.pbg_required}
                      onChange={formik.handleChange}
                    />
                  </h5>

                  <Row className="g-3">

                    {formik.values.pbg_details.pbg_required && (
                      <>
                        <Row className="mb-3">
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Number{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pbg_details.pbg_number"
                                placeholder="Enter PBG Number"
                                value={formik.values.pbg_details.pbg_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.pbg_number &&
                                  formik.touched.pbg_details?.pbg_number
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.touched.pbg_details?.pbg_number &&
                                  formik.errors.pbg_details?.pbg_number}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Date
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.pbg_date"
                                value={formik.values.pbg_details.pbg_date}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.pbg_date &&
                                  formik.touched.pbg_details?.pbg_date
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.touched.pbg_details?.pbg_date &&
                                  formik.errors.pbg_details?.pbg_date}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Bank Name{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pbg_details.bank_name"
                                placeholder="Enter Bank Name"
                                value={formik.values.pbg_details.bank_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.bank_name &&
                                  formik.touched.pbg_details?.bank_name
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.bank_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Amount{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="number"
                                name="pbg_details.amount"
                                min="0"
                                value={formik.values.pbg_details.amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.amount &&
                                  formik.touched.pbg_details?.amount
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.amount}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Validity{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.validity"
                                value={formik.values.pbg_details.validity}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.validity &&
                                  formik.touched.pbg_details?.validity
                                }
                                placeholder="e.g., 12 months"
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.validity}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Status{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Autocomplete
                                options={pbgStatusOptions}
                                value={formik.values.pbg_details.pbg_status || null}
                                onChange={(_, newValue) => {
                                  formik.setFieldValue("pbg_details.pbg_status", newValue || "");
                                }}
                                onBlur={() => {
                                  formik.setFieldTouched("pbg_details.pbg_status", true);
                                }}
                                ListboxProps={autocompleteDropdownStyles.ListboxProps}
                                renderOption={(props, option) =>
                                  autocompleteDropdownStyles.renderOption(
                                    props,
                                    option,
                                    (option: any) => option || ""
                                  )
                                }
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    placeholder="Select Status"
                                    size="small"
                                    error={
                                      !!formik.errors.pbg_details?.pbg_status &&
                                      formik.touched.pbg_details?.pbg_status
                                    }
                                    helperText={
                                      formik.touched.pbg_details?.pbg_status &&
                                      formik.errors.pbg_details?.pbg_status
                                    }
                                    sx={autocompleteDropdownStyles.inputSx}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <FileUpload
                              label="Upload Document"
                              multiple
                              maxFiles={1}
                              value={formik.values.pbg_details.upload_document}
                              onChange={(files) =>
                                formik.setFieldValue(
                                  "pbg_details.upload_document",
                                  files
                                )
                              }
                            />


                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>PBG Follow Up Date</Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.next_follow_up_date"
                                value={(formik.values.pbg_details as any)?.next_follow_up_date || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Row>

                </Row>
              </Col>
            </Row>

            <hr />
            {/* <Col xs={12} md={6}> */}
            <Row className="mb-3">
              <Col md={12}>
                <Row className="g-3">
                  <h5 className="mb-3 fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="EMD (Earnest Money Deposit) Details"
                      name="emd_applicable"
                      checked={formik.values.emd_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("mode_of_emd", "");
                          formik.setFieldValue("emd_amount", "");
                        }
                      }}
                    />
                  </h5>

                  {formik.values.emd_applicable && (
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Mode of EMD
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["BG", "DD", "NEFT/RTGS"]}
                            getOptionLabel={(option: any) => option}
                            value={formik.values.mode_of_emd || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("mode_of_emd", newValue || "");
                              if (!newValue) {
                                formik.setFieldValue("emd_amount", "");
                              }
                            }}
                            onBlur={() => formik.setFieldTouched("mode_of_emd", true)}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Mode of EMD"
                                size="small"
                                error={
                                  formik.touched.mode_of_emd &&
                                  !!formik.errors.mode_of_emd
                                }
                                helperText={
                                  formik.touched.mode_of_emd &&
                                  formik.errors.mode_of_emd
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            EMD Amount
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="emd_amount"
                            min="0"
                            placeholder="Enter EMD Amount"
                            value={formik.values.emd_amount || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              !!formik.errors.emd_amount &&
                              formik.touched.emd_amount
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.emd_amount}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Row>
              </Col>
            </Row>
            {/* </Row> */}
            {/* </Col> */}
            <hr />
            {/* Billing address section */}
            <Row>
              {/* BILLING FROM */}
              <h5 className="fw-semibold mb-3">Billing & Service Details</h5>
              <div
                className="p-3 rounded mb-3"
                style={{ backgroundColor: MecordColors.ActiveBackground }}
              >
                <Row>
                  <Col lg={6} md={12}>
                    <BillingFromAddress
                      value={formik.values.bill_from_address}
                      onChange={async (newValue) => {
                        await formik.setFieldValue("bill_from_address", newValue);
                        formik.setFieldTouched("bill_from_address", true);
                        // Validate the field after setting the value
                        await formik.validateField("bill_from_address");
                      }}
                      onBlur={async () => {
                        formik.setFieldTouched("bill_from_address", true);
                        await formik.validateField("bill_from_address");
                      }}
                      error={
                        formik.touched.bill_from_address
                          ? formik.errors.bill_from_address || undefined
                          : undefined
                      }
                    />
                  </Col>

                  {/* BILLING TO – OPTIONAL */}
                  <Col lg={6} md={12}>
                    <Form.Group>
                      <Form.Label >Bill to</Form.Label>

                      <Tooltip
                        title={formatFullAddress(formik.values.billing_address) || "No address available"}
                        arrow
                        placement="top"
                      >
                        <Form.Control
                          type="text"
                          name="billing_address.address"
                          placeholder="Autofill"
                          value={formatFullAddress(formik.values.billing_address) || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.billing_address &&
                            !!formik.errors.billing_address
                          }
                          disabled
                          style={{
                            cursor: "pointer",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}
                        />
                      </Tooltip>

                      <Form.Control.Feedback type="invalid">
                        {formik.errors.bill_to_address}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Row>



            <hr />
            <div id="items">
            <EnquiryServiceForm
              items={items}
              setItems={setItems}
              onAdd={handleProductAdd}
              // shippingAddresses={shippingAddresses}
              shippingAddresses={shippingAddresses}
              setShowAddressModal={setShowAddressModal}
              billFromAddress={formik.values.bill_from_address}
              composition_gst={formik.values.composition_gst}
              select_composition_gst={formik.values.select_composition_gst}
              currency_code={formik.values.currency_code}
              currency_symbol={formik.values.currency_symbol}
              exchange_rate={formik.values.exchange_rate}
              company_gst_type={formik.values.company?.gst_type}
              billToAddress={formik.values.billing_address}
              companyId={formik.values.company?.company_id || formik.values.company?.id}
              company={formik.values.company}
            />
            </div>

            {/* Totals Section */}
            <div className="row g-3 align-items-start">
              {/* LEFT SIDE - TERMS & CONDITIONS */}
              <Col lg={6} md={12}>

                <FormikProvider value={formik}>
                  <TermsConditionsSection />
                </FormikProvider>
                <Form.Group className="mt-3">
                  <Form.Label>Payment Terms Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="payment_terms_amount"
                    placeholder="Enter Payment Terms Amount"
                    value={formik.values.payment_terms_amount ?? ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.payment_terms_amount && !!formik.errors.payment_terms_amount}
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.payment_terms_amount}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              {/* RIGHT SIDE - TOTAL SUMMARY */}
              <Col lg={6} md={12}>
                <div className="">
                  <h5 className="fw-semibold mb-3">Total Summary</h5>

                  <div className="rounded p-3" style={{ backgroundColor: MecordColors.LightThemeBGColor }}>
                    <div className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>Service</div>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Subtotal (Before Discount):</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.subTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total Discount Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.discount || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Net Total:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.netTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total GST Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.gst || 0)}
                        </strong>
                      </Col>
                    </Row>

                    <hr />
                    <div className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>Accessories</div>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Subtotal (Before Discount):</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessorySubTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total Discount Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessoryDiscount || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Net Total:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessoryNetTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total GST Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessoryGst || 0)}
                        </strong>
                      </Col>
                    </Row>

                    <hr />
                    <Row>
                      <Col xs={8}>
                        <span className="fw-bold">Total Amount:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong className="fw-bold" style={{ fontSize: "1.2rem" }}>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.combinedGrandTotal ?? ((totals.grandTotal || 0) + (totals.accessoryGrandTotal || 0)))}
                        </strong>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </div>

            <hr />

            <Row className="">
              <Col md={12}>
                <RetentionDetails
                  value={formik.values.retention_details}
                  onChange={(newValue) =>
                    formik.setFieldValue("retention_details", newValue)
                  }
                  error={
                    formik.touched.retention_details
                      ? formik.errors.retention_details || undefined
                      : undefined
                  }
                  retentionTypeOptions={retentionTypeOptions}
                  baseAmount={totals.combinedNetTotal ?? totals.netTotal}
                  disabled={saving || savingDraft}
                />
              </Col>
            </Row>

            <hr />

            <Row className="g-3 mt-2">
              <Col md={6}>
                <NotesAndAttachments
                  notes={formik.values.notes || ""}
                  onNotesChange={(val) => formik.setFieldValue("notes", val)}
                  notesError={
                    formik.touched.notes ? (formik.errors.notes as any) : undefined
                  }
                  attachments={formik.values.attachments || []}
                  onAttachmentsChange={(files) =>
                    formik.setFieldValue("attachments", files)
                  }
                  disabled={saving || savingDraft}
                />
                
              </Col>
              <Col md={6}>
                <ScheduleFollowUp
                  value={{
                    next_follow_up_date: formik.values.next_follow_up_date || "",
                    follow_up_remarks: formik.values.follow_up_remarks || "",
                  }}
                  onChange={(val) => {
                    formik.setFieldValue("next_follow_up_date", val.next_follow_up_date);
                    formik.setFieldValue("follow_up_remarks", val.follow_up_remarks);
                    formik.setFieldTouched("next_follow_up_date", true, false);
                    if (val.next_follow_up_date?.trim()) {
                      setTimeout(() => formik.setFieldError("next_follow_up_date", undefined), 0);
                    }
                  }}
                  errors={{
                    next_follow_up_date:
                      formik.touched.next_follow_up_date
                        ? (formik.errors.next_follow_up_date as any)
                        : undefined,
                    follow_up_remarks:
                      formik.touched.follow_up_remarks
                        ? (formik.errors.follow_up_remarks as any)
                        : undefined,
                  }}
                  disabled={saving || savingDraft}
                />
              </Col>
            </Row>
            <Row className="g-3 mt-1 mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label> <h5 className="fw-semibold mb-3">Attachment Description</h5></Form.Label>
                  <Form.Control
                    type="text"
                    name="attachment_description"
                    placeholder="Enter attachment description"
                    value={formik.values.attachment_description || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      !!formik.errors.attachment_description &&
                      formik.touched.attachment_description
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.attachment_description}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {/* Footer Buttons */}
            <Row className="mt-3">
              <Col className="d-flex justify-content-center">
                <FormActionButtons
                  onCancel={() => navigate(`/sales_order/service/sales_order_log`)}
                  onSaveDraft={async () => {
                    formik.setFieldTouched("company", true);

                    const company = formik.values.company || (formik.values.company_name ? { company_name: formik.values.company_name, company_id: (formik.values as any).company_id } : null);

                    if (!company || (!company.company_name && !(company as any).company_id)) {
                      formik.setFieldError("company", "Please select a customer");
                      toast.error("Please select a customer");
                      return;
                    }

                    try {
                      await handleSubmitAction(formik.values, "draft");
                      navigate(`/sales_order/service/draft`);
                    } catch (err) {
                      // Error already handled in handleSubmitAction with toast
                    }
                  }}
                  onSave={async () => {
                    // Mark all fields as touched to show validation errors
                    const fields = Object.keys(formik.values);
                    const touchedFields: any = {};
                    fields.forEach((field) => {
                      touchedFields[field] = true;
                    });
                    formik.setTouched(touchedFields);

                    // Validate all fields first
                    const errors = await formik.validateForm();

                    // Debug: Log validation errors to help identify issues
                    if (Object.keys(errors).length > 0) {
                      // console.log("Validation errors:", errors);
                    }

                    // Check if there are actual validation errors (not just empty nested objects)
                    if (hasValidationErrors(errors)) {
                      formik.setErrors(errors);
                      setValidationAttemptCount((c) => c + 1);
                      // Show toast with first error message to help user
                      const firstError = Object.values(errors).find((err: any) =>
                        typeof err === 'string' && err.trim() !== ''
                      ) || "Please fix the validation errors";
                      if (typeof firstError === 'string') {
                        toast.error(firstError);
                      }
                      return;
                    }

                    if (!items || items.length === 0) {
                      toast.error("At least one service is required");
                      setTimeout(() => document.getElementById("items")?.scrollIntoView({ behavior: "smooth", block: "center" }), 100);
                      return;  // Return early to prevent navigation
                    }
                    // If validation passes, proceed with submission
                    try {
                      await handleSubmitAction(formik.values, "save");
                      // toast.success("Sales order saved successfully");
                      navigate(`/sales_order/service/sales_order_log`);
                    } catch (err) {
                      // Error already handled in handleSubmitAction with toast
                    }
                  }}
                  isSaving={saving}
                  isSavingDraft={savingDraft}
                  wrapperClassName="d-flex flex-wrap justify-content-center gap-3"
                />
              </Col>
            </Row>
          </Form>
 
   
          <AddCustomerModal
            show={showCompanyModal}
            onHide={() => setShowCompanyModal(false)}
            onSave={async () => {
              await dispatch(fetchCompanyByDropDown());
            }}
          />

       
            <Modal
              show={showServiceModal}
              onHide={() => setShowServiceModal(false)}
              backdrop="static"
              keyboard={false}
              size="xl"
              centered
            >
              <Modal.Header
                closeButton
                style={{
                  backgroundColor: MecordColors?.ThemeBGColor,
                  paddingBottom: "20px",
                }}
              >
                <Modal.Title style={{ color: "#fff" }}>
                  Add New Service
                </Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <ServiceFormModal
                  onSuccess={async () => {
                    await dispatch(fetchModelByDropDown());
                    setShowServiceModal(false);
                  }}
                  onCancel={() => setShowServiceModal(false)}
                />
              </Modal.Body>
            </Modal>
      
          <Modal
            show={showAddressModal}
            onHide={() => setShowAddressModal(false)}
            backdrop="static"
            keyboard={false}
            size="xl"
            centered
          >
            <Modal.Header
              closeButton
              style={{
                backgroundColor: MecordColors?.ThemeBGColor,
                paddingBottom: "20px",
              }}
            >
              <Modal.Title style={{ color: "#fff" }}>
                Add New Address
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              {formik.values.company && (
                <AddressFormModal
                  company_id={formik.values.company?.company_id || formik.values.company?.id}
                  formik={formik}
                  onSuccess={async (response: any) => {
                    // Only refetch company dropdown, don't refresh the page
                    const companiesResult = await dispatch(fetchCompanyByDropDown()).unwrap();
                    const updatedCompanies = companiesResult?.data || companiesResult || [];

                    // Find the updated company with new shipping addresses
                    const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
                    const updatedCompany = updatedCompanies.find(
                      (c: any) => c.id === currentCompanyId || c.company_id === currentCompanyId
                    );

                    // Update company object in formik with new shipping addresses
                    if (updatedCompany && updatedCompany.shipping_addresses) {
                      const formattedAddresses = updatedCompany.shipping_addresses.map(
                        (addr: any) => ({
                          id: addr.id || addr.shipping_address_id,
                          address: addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
                          state: addr.state,
                          city: addr.city,
                          pin_code: addr.pincode || addr.pin_code,
                          phone_number: addr.phone_number,
                        })
                      );

                      // Update shipping addresses state
                      setShippingAddresses(formattedAddresses);

                      // Update company object in formik
                      formik.setFieldValue("company", {
                        ...formik.values.company,
                        shipping_addresses: updatedCompany.shipping_addresses,
                      }, false);
                    }

                    setShowAddressModal(false);
                  }}
                  onCancel={() => setShowAddressModal(false)}
                />
              )}
            </Modal.Body>
          </Modal>
        </PageContainer>
      </>
    );
  };

export default AddServicesSalesOrderForm;

